import React, { useState, useRef, useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { functions } from "../lib/appwrite";
import img1 from "../assets/img1.webp";
import pinkoval from "../assets/pinkoval.webp";

import bubbleleft from "../assets/bubbleleft-2.webp";
import bubbleright from "../assets/bubbleright.webp";
import libg from "../assets/AssessmentIntroduction.png";
import "./style.css";
import test2 from "../assets/secondpic.png";
import icon1 from "../assets/icon1.webp";
import icon2 from "../assets/icon2.webp";
import icon3 from "../assets/icon3-1.webp";
import icon4 from "../assets/icon4.webp";
import icon5 from "../assets/icon5.webp";
import icon6 from "../assets/icon6.webp";
import icon7 from "../assets/icon7.webp";
import icon8 from "../assets/icon8.webp";
import linkedinn from "../assets/linkedin.svg";
import diamonds from "../assets/diamonds.webp";
import diamonds3 from "../assets/diamonds3.webp";
import cubebottom from "../assets/cubebottomm-2.webp";
import logo from "../assets/logo.svg";
import Randomwalk from "../assets/Randomwalk.svg";
import SvgComponent from "./SvgComponent";
import pink_blue_right from "../assets/pink_blue_right.webp";
import twitterr from "../assets/twitter.svg";
import { Link } from "react-scroll";
import { Client, Databases, ID } from "appwrite";
import youtubee from "../assets/youtube.webp";
import { Helmet } from "react-helmet-async";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import bgimg1 from "../assets/bgimg1.webp";
import journey from "../assets/AIjourney.mp4";
import loading from "../pages/loading.json";
import {
  Link as ScrollLink,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller,
} from "react-scroll";
import aibg from "../assets/aibg.webp";
import formpic from "../assets/formpic.webp";
import config from "../../../config/config";
import {
  parsePhoneNumberFromString,
  isValidPhoneNumber,
} from "libphonenumber-js";
import "react-phone-number-input/style.css";
import BusinessPage from "../components/BusinessPage";
import CTAPage from "../components/CTAPage";
const LiteracyPage = () => {
  const [animate, setAnimate] = useState(false);
  const [country, setCountry] = useState("");
  const [isLoadingCheckout, setIsLoadingCheckout] = useState(false);
  const [isLoadingLiteracy, setIsLoadingLiteracy] = useState(false);

  const getIpAddress = async () => {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    console.log("getipaddress -> data", data);
    //get country code
    const response2 = await fetch(
      `https://geo.ipify.org/api/v2/country?apiKey=at_5EMDuyXpWbueG9hj9nfzGLi2yDTbC&ipAddress=${data.ip}`
    );
    const data2 = await response2.json();
    console.log("getipaddress -> data2", data2);
    return data2.location.country;
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setAnimate(true);
          observer.disconnect();
        }
      });
    });

    observer.observe(document.querySelector(".animate-section"));

    return () => observer.disconnect();
  }, []);


  useEffect(() => {
    // This will run whenever the country state changes
    if (country) {
      // Find and focus the country dropdown to make the selection visible to user
      const countrySelect = document.getElementById("country-name-form");
      if (countrySelect) {
        countrySelect.value = country;
      }
    }
  }, [country]);
  const fetchPostalCodeData = async (postalCode) => {
    try {
      // Using a postal code API (replace with your preferred API)
      const response = await fetch(
        `https://api.postalpincode.in/pincode/${postalCode}`
      );
      const data = await response.json();

      if (data && data[0].Status === "Success") {
        const postOffice = data[0].PostOffice[0];
        return {
          city: postOffice.Block || postOffice.Name,
          state: postOffice.State,
          country: "IN", // Since you're using India's postal API
        };
      }
      return null;
    } catch (error) {
      console.error("Error fetching postal code data:", error);
      return null;
    }
  };

  useEffect(() => {
    if (animate) {
      const ballRef = document.querySelector(".ball-image");
      const textElements = document.querySelectorAll(".text-animate");
      const pinkOvalRef = document.querySelector(".pink-oval");

      if (ballRef) {
        ballRef.style.animation = "slide-right 2.5s ease-out forwards";
      }

      if (textElements) {
        textElements.forEach((element, index) => {
          element.style.animation = `slide-up 2.5s ease-out forwards`;
          element.style.animationDelay = `${index * 0}s`; // Adjusted delay for text
        });
      }

      if (pinkOvalRef) {
        pinkOvalRef.style.animationDelay = `${textElements.length * 0.5}s`;
      }
    }
  }, [animate]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);

  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [designation, setDesignation] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmailId] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [errors, setErrors] = useState({});
  const [jobTitle, setjobTtitle] = useState("");
  const [literacycompanyName, setLiteracyCompanyName] = useState("");

  const [isLiteracyFormOpen, setIsLiteracyFormOpen] = useState(false);
  const [hasFormBeenShown, setHasFormBeenShown] = useState(false);
  const [pageFullyLoaded, setPageFullyLoaded] = useState(false);

  const tabIdRef = useRef(null);
  const isMounted = useRef(false);
  const location = useLocation();



  useEffect(() => {
    isMounted.current = true;

    // Initialize the tab ID if not already set for this session
    if (!tabIdRef.current) {
      const existingId = sessionStorage.getItem("literacy-tab-id");
      if (existingId) {
        tabIdRef.current = existingId;
      } else {
        const newId =
          Date.now().toString() + Math.random().toString(36).substring(2, 9);
        sessionStorage.setItem("literacy-tab-id", newId);
        tabIdRef.current = newId;
      }
    }

    // If on the literacy page, clear flags to ensure auto-open for this load/reload/navigation-to.
    if (location.pathname === "/ai-readiness-index/for-literacy") {
      if (tabIdRef.current) {
        // Use the same logic as getStorageKey() or construct keys directly
        const storageKeyToClear = `literacy-form-shown-${tabIdRef.current}`;
        const manualCloseKeyToClear = `literacy-form-manually-closed-${tabIdRef.current}`;

        sessionStorage.removeItem(storageKeyToClear);
        sessionStorage.removeItem(manualCloseKeyToClear);
  
      }
    }

 
    if (document.readyState === "complete") {
      if (isMounted.current) {
        setPageFullyLoaded(true);
      }
    }

    return () => {
      isMounted.current = false;
    };
  }, [location.pathname]); // CHANGED dependency array from [] to [location.pathname]

  const getStorageKey = () => {
    return `literacy-form-shown-${tabIdRef.current || "default"}`;
  };

  useEffect(() => {
    // Early exit if not on the correct path, page not loaded, or tabId not yet resolved.
    if (
      location.pathname !== "/ai-readiness-index/for-literacy" ||
      !pageFullyLoaded ||
      !tabIdRef.current
    ) {
      return;
    }

    const storageKey = getStorageKey(); // e.g., literacy-form-shown-XYZ
    const manualCloseKey = `literacy-form-manually-closed-${tabIdRef.current}`;

    // If the form is already open, OR it was already auto-shown, OR it was manually closed,
    // then do nothing.
    if (
      isLiteracyFormOpen ||
      sessionStorage.getItem(storageKey) ||
      sessionStorage.getItem(manualCloseKey)
    ) {
      // Defensive: if form is open but somehow not marked in session (and not manually closed), mark it.
      if (
        isLiteracyFormOpen &&
        !sessionStorage.getItem(storageKey) &&
        !sessionStorage.getItem(manualCloseKey)
      ) {
        sessionStorage.setItem(storageKey, "true");
      }
      return;
    }

    // If we reach here, conditions are met to auto-open.
    console.log(
      "Literacy path: Conditions met to scroll and open form. Tab ID:",
      tabIdRef.current
    );

    const businessSection = document.getElementById("business-section");
    if (businessSection) {
      businessSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      const formOpenTimeout = setTimeout(() => {
        if (isMounted.current) {
          // Re-check conditions before opening, especially the manualCloseKey
          if (
            !isLiteracyFormOpen &&
            !sessionStorage.getItem(storageKey) &&
            !sessionStorage.getItem(manualCloseKey)
          ) {
            console.log(
              "Timeout: Opening literacy form and setting 'shown' flag in session storage."
            );
            setIsLiteracyFormOpen(true);
            sessionStorage.setItem(storageKey, "true"); // Mark that it has been auto-shown
          } else {
            console.log(
              "Timeout: Form was already open, shown, or manually closed during the timeout interval."
            );
            if (
              isLiteracyFormOpen &&
              !sessionStorage.getItem(storageKey) &&
              !sessionStorage.getItem(manualCloseKey)
            ) {
              sessionStorage.setItem(storageKey, "true");
            }
          }
        }
      }, 1000);

      return () => clearTimeout(formOpenTimeout);
    } else {
      console.error("Business section element not found for scrolling!");
    }
  }, [
    location.pathname,
    pageFullyLoaded,
    tabIdRef.current,
    isLiteracyFormOpen,
  ]);

  useEffect(() => {
    const previousPathname = location.pathname; // Capture pathname when the effect (or its deps) run

    return () => {
      // This cleanup function runs when the component unmounts
      // OR before the effect re-runs if 'location.pathname' changes.

      // Check if we WERE on the literacy page and the NEW location.pathname is DIFFERENT.
      if (
        previousPathname === "/ai-readiness-index/for-literacy" &&
        location.pathname !== "/ai-readiness-index/for-literacy"
      ) {
        if (tabIdRef.current) {
          console.log(
            "Navigated away from literacy page. Clearing all related session flags for tab:",
            tabIdRef.current
          );
          const storageKey = getStorageKey(); // e.g., literacy-form-shown-XYZ
          const manualCloseKey = `literacy-form-manually-closed-${tabIdRef.current}`;

          sessionStorage.removeItem(storageKey);
          sessionStorage.removeItem(manualCloseKey);

          // if (setHasFormBeenShown) { // If you have this state and it needs resetting
          //  setHasFormBeenShown(false);
          // }
        }
      }
    };
  }, [location.pathname]);

  useEffect(() => {
    const handleWindowLoad = () => {
      if (isMounted.current) {
        console.log(
          "Window load event fired, setting pageFullyLoaded to true."
        );
        setPageFullyLoaded(true);
      }
    };

    if (document.readyState === "complete") {
      setPageFullyLoaded(true);
    } else {
      window.addEventListener("load", handleWindowLoad);
    }

    return () => {
      window.removeEventListener("load", handleWindowLoad);
    };
  }, []);

  const handleButtonClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false); // For the general consultation modal
    setIsFormOpen(false); // For the business payment form
    if (
      isLiteracyFormOpen && // Check if it was the literacy form that was open
      location.pathname === "/ai-readiness-index/for-literacy" &&
      tabIdRef.current && pageFullyLoaded 
    ) {
      const manualCloseKey = `literacy-form-manually-closed-${tabIdRef.current}`;
      sessionStorage.setItem(manualCloseKey, "true");
      console.log(
        "Manually closed literacy form, set manualCloseKey in session storage:",
        manualCloseKey
      );
    }
    setIsLiteracyFormOpen(false); // Close literacy form
    resetForm(); // This should reset form field states, step, errors, etc.
  };

  const client = new Client()
    .setEndpoint("https://api.ai-readiness.app/v1")
    .setProject("aireadinessindexpayment");

  const databases = new Databases(client);

  // Validation function
  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    // Validate Name
    if (!firstName) {
      newErrors.name = "Name is required.";
      isValid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(firstName)) {
      newErrors.name =
        "Name can only contain alphabetic characters and spaces.";
      isValid = false;
    }

    // Validate Company Name
    if (!companyName) {
      newErrors.companyName = "Company Name is required.";
      isValid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(companyName)) {
      newErrors.companyName =
        "Company Name can only contain alphabetic characters and spaces.";
      isValid = false;
    }

    // Validate Phone Number
    if (!phoneNumber) {
      newErrors.phoneNumber = "Mobile Number is required.";
      isValid = false;
    } else {
      if (countryCode === "91") {
        const validStartDigits = /^[6789]/;
        if (phoneNumber.length !== 12) {
          newErrors.phoneNumber =
            "Contact Number for India must be exactly 10 digits.";
          isValid = false;
        } else if (!validStartDigits.test(phoneNumber.slice(-10))) {
          newErrors.phoneNumber =
            "Contact Number for India must start with 6, 7, 8, or 9.";
          isValid = false;
        } else if (!isValidPhone) {
          newErrors.phoneNumber = "Contact Number is invalid.";
          isValid = false;
        }
      } else if (!isValidPhone) {
        newErrors.phoneNumber = "Contact Number is invalid.";
        isValid = false;
      }
    }

    // Validate Email
    if (!email) {
      newErrors.email = "Email Id is required.";
      isValid = false;
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
    ) {
      newErrors.email = "Email Id is invalid.";
      isValid = false;
    }

    // Set errors and return validation status
    setErrors(newErrors);
    return isValid;
  };

  const handlePhoneNumberChange = (phone, country) => {
    // Remove the country dial code and any non-numeric characters from the Phone Number
    const cleanPhone = phone
      .replace(new RegExp(`^\\+${country.dialCode}`), "")
      .replace(/\D/g, "");

    // Update the Phone Number and country code states
    setPhoneNumber(cleanPhone);
    setCountryCode(country.dialCode);
    console.log(cleanPhone);
  };

  const isValidPhone = useMemo(() => {
    return isValidPhoneNumber("+" + phoneNumber);
  }, [phoneNumber]);

  const createCheckoutSession = async (forLiteracy) => {
    try {
      console.log(
        "Creating check::",
        userName,
        email,
        userphoneNumber,
        userCompanyName
      );
      const response = await functions.createExecution(
        "CreateStripeCheckoutSession",
        JSON.stringify({
          email: email,
          name: userName,
          phone: userphoneNumber,
          userCompany: userCompanyName || null,
          line1: street,
          city: city,
          state: state,
          zip: zip,
          country: country,
          academyxi: false,
          forAILiteracy: forLiteracy,
        })
      );
      const redirectUrl = JSON.parse(response.responseBody).redirectUrl;
      setTimeout(() => {
        window.location.href = redirectUrl;
        // window.open(redirectUrl, "_blank");
      }, 100);
    } catch (error) {
      console.error("Error creating checkout session:", error);
      if (forLiteracy) {
        setIsLoadingLiteracy(false);
      } else {
        setIsLoadingCheckout(false);
      }
    }
    // createCheckoutSession();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await databases.createDocument(
        "lead-details",
        "lead-forms",
        ID.unique(),
        {
          firstName,
          lastName,
          designation,
          companyName,
          phoneNumber,
          email,
        }
      );
      // Close the modal and show success message
      setIsModalOpen(false);
      setIsSuccessOpen(true);
    } catch (error) {
      console.error("Error creating document:", error);
    }
  };

  const closeSuccessModal = () => {
    setIsSuccessOpen(false);
  };

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [userName, setUserName] = useState(""); //used as first name for payment form
  const [userphoneNumber, setusersphoneNumber] = useState("");
  const [userDesignation, setUserDesignation] = useState("");
  const [userCompanyName, setUserCompanyName] = useState("");
  const [checklist, setChecklist] = useState(true);
  const [gstNumber, setGstNumber] = useState("");
  const [street, setstreet] = useState("");

  const [step, setStep] = useState(1);
  const [showStep1Errors, setShowStep1Errors] = useState(false);
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  // const [country, setCountry] = useState('');
  const [zip, setzip] = useState("");

  const [showStep2Errors, setShowStep2Errors] = useState(false);

  const handleOpenForm = () => { 
    resetForm(); 
    setIsLiteracyFormOpen(false); 
    setIsFormOpen(true);
    setStep(1);
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
    setStep(1);
  };

  // };

  const handleOpenFormLiteracy = () => {
    resetForm(); 
    setIsFormOpen(false); 
    setIsLiteracyFormOpen(true);
    setStep(1); 
  };

  useEffect(() => {
      if (showStep1Errors) {
        validateStep1(); 
      }
    }, [
  
      userName,
      lastName,
      userphoneNumber,
      email,
      userDesignation,
      userCompanyName,
      jobTitle,
      literacycompanyName,
      showStep1Errors,
      isFormOpen,       
      isLiteracyFormOpen 
    ]);
    
    // The useEffect for showStep2Errors should remain as is, as validateStep2 is common.
    useEffect(() => {
      if (showStep2Errors) {
        validateStep2();
      }
    }, [
      gstNumber,
      street,
      city,
      state,
      country,
      zip,
      showStep2Errors,
    ]);












  const validateStep1 = () => {
    let isValid = true;
    const newErrors = {};

    // --- Common validations for Step 1 of BOTH forms ---
    if (userName.trim() === "") {
      newErrors.userName = "Required*";
      isValid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(userName)) {
      newErrors.userName =
        "Name can only contain alphabetic characters and spaces.";
      isValid = false;
    }

    if (lastName.trim() === "") {
      newErrors.lastName = "Required*";
      isValid = false;
    }
    // Add more specific validation for last name if needed, e.g., !/^[a-zA-Z\s]+$/

    if (userphoneNumber.trim() === "") { // Assuming userphoneNumber is for payment forms
      newErrors.userphoneNumber = "Required*";
      isValid = false;
    }
    // Add more specific phone validation if needed, similar to the schedule consultation form

    if (email.trim() === "") {
      newErrors.email = "Required*";
      isValid = false;
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
    ) {
      newErrors.email = "Email Id is invalid.";
      isValid = false;
    }

    // --- Specific validations based on which form is open ---
    if (isFormOpen && !isLiteracyFormOpen) { // Business Form ($499)
      if (userDesignation.trim() === "") {
        newErrors.userDesignation = "Required*";
        isValid = false;
      }else if  (!/^[a-zA-Z\s.,@&()\-_/']+$/.test(userDesignation)) {
        newErrors.userDesignation =
          "Job Title can include letters, spaces, and special characters.";
        isValid = false;
      }
      // Add any other regex or specific validation for userDesignation if needed

      if (userCompanyName.trim() === "") {
        newErrors.userCompanyName = "Required*";
        isValid = false;
      } else if  (!/^[a-zA-Z0-9\s.,@&()\-_/']+$/.test(userCompanyName)) {
        newErrors.userCompanyName =
        "Company Name can include letters, numbers, and special characters.";
        isValid = false;
      }
      
    } else if (isLiteracyFormOpen && !isFormOpen) { // Literacy Form ($10)
      if (jobTitle.trim() === "") {
        newErrors.jobTitle = "Required*";
        isValid = false;
      } else if  (!/^[a-zA-Z\s.,@&()\-_/']+$/.test(jobTitle)) {
        newErrors.jobTitle =
          "Job Title can include letters, spaces, and special characters.";
        isValid = false;
      }
      // Add any other regex or specific validation for jobTitle if needed

      if (literacycompanyName.trim() === "") {
        newErrors.literacycompanyName = "Required*";
        isValid = false;
      } else if  (!/^[a-zA-Z0-9\s.,@&()\-_/']+$/.test(literacycompanyName)) {
        newErrors.literacycompanyName =
        "Company Name can include letters, numbers, and special characters.";
        isValid = false;
      }
      
    }

    setErrors(newErrors);
    return isValid;
  };

  const validateStep2 = () => {
    let isValid = true; // Initialize isValid to true
    const newErrors = {};

    // Validate Street
    // Validate Street
    if (street.trim() === "") {
      newErrors.street = "Required*";
      isValid = false;
    } else if (!/^[a-zA-Z0-9\s.,'’\-#/]+$/.test(street)) {
      newErrors.street =
        "Street can contain letters, numbers, spaces, and common symbols like . , ' - # /";
      isValid = false;
    }

    // Validate City
    if (city.trim() === "") {
      newErrors.city = "Required*";
      isValid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(city)) {
      newErrors.city =
        "City can only contain alphabetic characters and spaces.";
      isValid = false;
    }

    // Validate State
    if (state.trim() === "") {
      newErrors.state = "Required*";
      isValid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(state)) {
      newErrors.state =
        "State can only contain alphabetic characters and spaces.";
      isValid = false;
    }

    // Validate Country
    if (country.trim() === "") {
      newErrors.country = "Required*";
      isValid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(country)) {
      newErrors.country =
        "Country can only contain alphabetic characters and spaces.";
      isValid = false;
    }

    // Validate ZIP Code
    if (zip.trim() === "") {
      newErrors.zip = "Required*";
      isValid = false;
    } else if (zip.length < 3) {
      newErrors.zip = "Enter a valid Postal code";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid; // Return the validation status
  };

  useEffect(() => {
    if (showStep1Errors) {
      validateStep1();
    }
    if (showStep2Errors) {
      validateStep2();
    }
  }, [
    userName, //used as first name for payment page
    lastName, //used as last name for payment page
    userphoneNumber,
    userDesignation,
    userCompanyName,
    email,
    gstNumber,
    street,
    city,
    state,
    country,
    zip,
    showStep1Errors,
    showStep2Errors,
  ]);

  const handleFormSubmit = async (event) => {
    event.preventDefault(); // Prevent form from submitting immediately
    setShowStep2Errors(true);
    const isValidStep2 = validateStep2();
    // Validate form data before proceeding
    if (!isValidStep2) {
      return;
    }
    //if form is valid, create document in the database
    if (isValidStep2) {
      try {
        // Create document in the database
        const document = await databases.createDocument(
          "lead-details", // Database ID
          "payment-form", // Collection ID
          ID.unique(), // Unique document ID
          {
            userName,
            lastName,
            userphoneNumber,
            userDesignation,
            userCompanyName,
            email,
            gstNumber,
            street,
            city,
            state,
            country,
            zip,
          }
        );

        console.log("Document created successfully:", document);

        // Close the form and reset the step
        // setIsFormOpen(false);
        // setStep(1);

        // After document creation, handle the checkout session
        await createCheckoutSession(false);
      } catch (error) {
        console.error("Error creating document:", error);
      }
    }
  };
  const handleLiteracyFormSubmit = async (event) => {
    event.preventDefault(); // Prevent form from submitting immediately
    setShowStep2Errors(true);
    const isValidStep2 = validateStep2();
    // Validate form data before proceeding
    if (!isValidStep2) {
      return;
    }
    //if form is valid, create document in the database
    if (isValidStep2) {
      try {
        // Create document in the database
        const document = await databases.createDocument(
          "literacy-lead-details", // Database ID
          "literacy-payment-form", // Collection ID
          ID.unique(), // Unique document ID
          {
            userName,
            lastName,
            userphoneNumber,
            email,
            gstNumber,
            street,
            city,
            state,
            country,
            zip,
            checklist: checklist ? "Yes" : "No",
            jobTitle,
            literacycompanyName,
          }
        );

        console.log("Document created successfully for literacy:", document);

        // Close the form and reset the step
        // setIsLiteracyFormOpen(false);
        // setStep(1);

        // After document creation, handle the checkout session
        await createCheckoutSession(true);
      } catch (error) {
        console.error("Error creating document:", error);
      }
    }
  };

  const handleNextClick = () => {
    setShowStep1Errors(true);

    if (validateStep1()) {
      setStep(2);
    }
  };

  const handleClick = async (event) => {
    event.preventDefault();
    setShowStep2Errors(true);

    const isValidStep2 = validateStep2();
    if (!isValidStep2) {
      return;
    }

    setIsLoadingCheckout(true);

    try {
      const document = await databases.createDocument(
        "lead-details",
        "payment-form",
        ID.unique(),
        {
          userName,
          lastName,
          userphoneNumber,
          userDesignation,
          userCompanyName,
          email,
          gstNumber,
          street,
          city,
          state,
          country,
          zip,
        }
      );

      console.log("Document created successfully:", document);

      // Only navigate after document creation
      await createCheckoutSession(false);

      // Do NOT reset loading here if the user is leaving the page
    } catch (error) {
      console.error("Error creating document:", error);
      setIsLoadingCheckout(false);
    }
  };

  // const handleClickLiteracy = async (event) => {
  //   setIsLoadingLiteracy(true); // Show loader
  //   await handleLiteracyFormSubmit(event);
  // };

  // Add this resetForm function in your component
  const handleClickLiteracy = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    setShowStep2Errors(true);

    const isValidStep2 = validateStep2();
    if (!isValidStep2) {
      return;
    }

    setIsLoadingLiteracy(true);

    try {
      // Create document
      await databases.createDocument(
        "literacy-lead-details",
        "literacy-payment-form",
        ID.unique(),
        {
          userName,
          lastName,
          userphoneNumber,
          email,
          gstNumber,
          street,
          city,
          state,
          country,
          zip,
          checklist: checklist ? "Yes" : "No",
          jobTitle,
          literacycompanyName,
        }
      );

      // Set flag for cleanup
      localStorage.setItem("literacyFormSubmitted", "true");

      createCheckoutSession(true);
    } catch (error) {
      console.error("Error creating document:", error);
      setIsLoadingLiteracy(false);
      alert("There was an error processing your request. Please try again.");
    }
  };

  // Handle cleanup on component mount/page load
  useEffect(() => {
    const formSubmitted = localStorage.getItem("literacyFormSubmitted");
    if (formSubmitted === "true") {
      resetForm();
      localStorage.removeItem("literacyFormSubmitted");
    }
  }, []);

  // Enhanced resetForm function
  const resetForm = () => {
    // Reset all form fields
    setUserName("");
    setlastName("");
    setusersphoneNumber("");
    setUserDesignation("");
    setUserCompanyName("");
    setEmailId("");
    setjobTtitle("");
    setLiteracyCompanyName("");
    setGstNumber("");
    setstreet("");
    setCity("");
    setState("");
    setCountry("");
    setzip("");
    setChecklist(true);

    // Reset form state
    setStep(1);
    setShowStep1Errors(false);
    setShowStep2Errors(false);
    setIsLoadingLiteracy(false); // This resets the button when user returns
    setIsFormOpen(false);
    setIsLiteracyFormOpen(false);

    // Clear any errors
    setErrors({});
  };

  // Enhanced Back button handler
  const handleBackButton = () => {
    if (isLoadingLiteracy) {
      setIsLoadingLiteracy(false);
    }
    setStep(1);
  };

  // Handle page visibility - reset loading when user returns from Stripe
  useEffect(() => {
    const handleVisibilityChange = () => {
      // When user comes back to the page (from Stripe), reset loading state
      if (!document.hidden && isLoadingLiteracy) {
        setIsLoadingLiteracy(false);
      }
    };

    const handleFocus = () => {
      // Also handle when window gets focus (user comes back from Stripe)
      if (isLoadingLiteracy) {
        setIsLoadingLiteracy(false);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", handleFocus);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", handleFocus);
    };
  }, [isLoadingLiteracy]);

  const paragraphs = [
    "Many companies struggle to understand their readiness for AI adoption and their overall digital maturity.",
    "Did you know that over 77% of companies globally are actively exploring how to incorporate AI into their business?",
    "While there's immense enthusiasm for AI, many companies lack a clear understanding of their AI readiness.",
  ];

  const [currentParagraph, setCurrentParagraph] = useState(0);
  const [previousParagraph, setPreviousParagraph] = useState(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setPreviousParagraph(currentParagraph);
      setCurrentParagraph((prev) => (prev + 1) % paragraphs.length);
    }, 3000); // Adjust timing as needed

    return () => clearInterval(interval);
  }, [currentParagraph]);

  const rectangles = [
    {
      text: "Does your leadership have a clear vision for AI, and are they committed to its success?",
      imgSrc: icon1,
    },
    {
      text: "Are your business goals aligned with potential AI applications?",
      imgSrc: icon2,
    },
    {
      text: "Do you have the necessary data infrastructure and talent pool to support AI initiatives?",
      imgSrc: icon3,
    },
    {
      text: "Does your company foster a culture of innovation and experimentation?",
      imgSrc: icon4,
    },
    {
      text: "How digitally mature are your various departments?",
      imgSrc: icon5,
    },
  ];

  let startXRef = useRef(0); // Reference to store initial X position on mouse down
  const scrollContainerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startScrollLeft, setStartScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    startXRef.current = e.pageX;
    setStartScrollLeft(scrollContainerRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const container = scrollContainerRef.current;
    const distance = e.pageX - startXRef.current;
    const maxScrollDistance = container.scrollWidth - container.clientWidth;

    let newScrollLeft = startScrollLeft - distance;

    // Implement circular scrolling behavior
    if (newScrollLeft < 0) {
      newScrollLeft = maxScrollDistance + newScrollLeft; // Wrap around to the end
    } else if (newScrollLeft > maxScrollDistance) {
      newScrollLeft = newScrollLeft - maxScrollDistance; // Wrap around to the beginning
    }

    container.scrollLeft = newScrollLeft;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const scrollToNext = () => {
    const container = scrollContainerRef.current;
    const cardWidth = container.firstElementChild.clientWidth; // Get width of the first card
    const scrollDistance = cardWidth + 20; // Adjust as needed, considering margin/padding

    container.scrollLeft += scrollDistance;
  };

  const scrollToPrevious = () => {
    const container = scrollContainerRef.current;
    const cardWidth = container.firstElementChild.clientWidth; // Get width of the first card
    const scrollDistance = cardWidth + 20; // Adjust as needed, considering margin/padding

    container.scrollLeft -= scrollDistance;
  };

  const [servicesOpen, setServicesOpen] = useState(false);
  const [companyOpen, setCompanyOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);

  const toggleServices = () => {
    setServicesOpen(!servicesOpen);
    setCompanyOpen(false);
    setResourcesOpen(false);
  };

  const toggleCompany = () => {
    setCompanyOpen(!companyOpen);
    setServicesOpen(false);
    setResourcesOpen(false);
  };

  const toggleResources = () => {
    setResourcesOpen(!resourcesOpen);
    setServicesOpen(false);
    setCompanyOpen(false);
  };

  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleScroll = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setActiveSection(entry.target.id);
      }
    });
  };

  // const [currentIndex, setCurrentIndex] = useState(0);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  //   }, 2000); // Change image every 3 seconds
  //   return () => clearInterval(interval);
  // }, []);
  // const handleScrollLeft = () => {
  //   if (scrollContainerRef.current) {
  //     scrollContainerRef.current.scrollBy({
  //       left: -400, // Adjust the scroll amount as needed
  //       behavior: "smooth",
  //     });
  //   }
  // };

  // const handleScrollRight = () => {
  //   if (scrollContainerRef.current) {
  //     scrollContainerRef.current.scrollBy({
  //       left: 400, // Adjust the scroll amount as needed
  //       behavior: "smooth",
  //     });
  //   }
  // };

  const handleScrollLeft = () => {
    if (scrollContainerRef.current) {
      const card = scrollContainerRef.current.querySelector(".card");
      if (card) {
        const cardStyle = window.getComputedStyle(card);
        const cardWidth = card.offsetWidth; // Width of the card
        const marginRight = parseInt(cardStyle.marginRight); // Right margin of the card

        const totalCardWidth = cardWidth + marginRight; // Total width including margin

        scrollContainerRef.current.scrollBy({
          left: -totalCardWidth, // Scroll to the previous card
          behavior: "smooth",
        });
      }
    }
  };

  const handleScrollRight = () => {
    if (scrollContainerRef.current) {
      const card = scrollContainerRef.current.querySelector(".card");
      if (card) {
        const cardStyle = window.getComputedStyle(card);
        const cardWidth = card.offsetWidth; // Width of the card
        const marginRight = parseInt(cardStyle.marginRight); // Right margin of the card

        const totalCardWidth = cardWidth + marginRight; // Total width including margin

        scrollContainerRef.current.scrollBy({
          left: totalCardWidth, // Scroll to the next card
          behavior: "smooth",
        });
      }
    }
  };

  useEffect(() => {
    const options = {
      threshold: 0.5, // Adjust this value to determine when a section is considered in view
    };

    const observer = new IntersectionObserver(handleScroll, options);

    const sections = document.querySelectorAll("section");
    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, []);

  const handleSetActiveLink = (link) => {
    setActiveLink(link);
  };

  const [activeLink, setActiveLink] = useState("t1"); // Default active link

  useEffect(() => {
    // Function to handle scroll events
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      // Calculate the top offset of each section
      const t1Section = document.getElementById("t1").offsetTop;
      const t2Section = document.getElementById("t2").offsetTop;
      const t3Section = document.getElementById("t3").offsetTop;
      const t4Section = document.getElementById("t4").offsetTop;

      // Determine which section is in view based on scroll position
      if (scrollPosition >= t1Section && scrollPosition < t2Section - 100) {
        setActiveLink("t1");
        setMenuOpen(false);
      } else if (
        scrollPosition >= t2Section - 100 &&
        scrollPosition < t3Section - 100
      ) {
        setActiveLink("t2");
        setMenuOpen(false);
      } else if (
        scrollPosition >= t3Section - 100 &&
        scrollPosition < t4Section - 100
      ) {
        setActiveLink("t3");
        setMenuOpen(false);
      } else if (scrollPosition >= t4Section - 100) {
        setActiveLink("t4");
        setMenuOpen(false);
      }
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures this effect runs only once

  const [isVisible, setIsVisible] = useState(false);
  const observerRef = useRef(null);

  useEffect(() => {
    const currentElement = observerRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        // settrigger everytime

        // set trigger once
        if (entry.isIntersecting && !isVisible) {
          setIsVisible(true);
          observer.unobserve(currentElement); // Stop observing after it has triggered
        }
      },
      {
        root: null, // Observe relative to the viewport
        rootMargin: "0px",
        threshold: 0.3, // Trigger when 10% of the target is visible
      }
    );

    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, []);

  return (
    <>
      <div className="Main ">
        <div id="t1">
          <div className="bg-gradient-custom p-4 flex justify-center items-center ">
            <div className="relative w-full h-screen overflow-hidden">
              <div className="absolute top-40  md:top-60  lg:top-44 left-4 2xl:left-44 2xl:top-64  md:left-20 lg:left-20 text-container text-white -space-y-0 z-10">
                <p className="  bg-custom-gradient3 text-thin font-display text-white text-2xl mt-[-70px] rounded-lg px-2">
                  AI Readiness & Digital Maturity Assessment Index
                </p>
                <br />
                <p className="top-paragraph text-2xl lg:text-6xl md:text-4xl 2xl:text-7xl  font-display font-bold">
                  Don't just dream of <br />
                  <span className="gradient-text">AI transformation,</span>{" "}
                  <br />
                  make it a reality.
                </p>
                <br />
                <button
                  id="know-more"
                  className="border border-1 font-display border-[#C77DF0] text-[#C77DF0] rounded-full px-4 py-2 -z-10 mt-4"
                  onClick={() =>
                    document
                      .getElementById("learn-more-section")
                      .scrollIntoView({
                        behavior: "smooth",
                      })
                  }
                >
                  Learn More
                </button>
              </div>
              <div>
                <SvgComponent />
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:items-center bg-white -mb-4">
            <div className="flex-1 mb-5 md:mb-0 ">
              <img
                src={img1}
                alt="Description of the image"
                className=" max-w-xs md:max-w-sm lg:max-w-lg 2xl:max-w-2xl h:auto "
              />
            </div>

            <div className="flex-2 md:ml-5 flex flex-col items-center -mt-4">
              <div
                className="mt-2 flex flex-col items-center space-y-8 max-w-md text-md md:text-md lg:text-lg 2xl:text-2xl sm:mb-20 md:max-w-lg lg:max-w-3xl 2xl:max-w-6xl relative font-display"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <div
                  className="p-8 rounded w-full h-40 relative overflow-hidden -top-[30px] sm:top-0 "
                  style={{
                    backgroundImage: `url(${pink_blue_right})`,
                    backgroundSize: " cover",
                    backgroundPosition: "50% 65%",
                  }}
                >
                  {paragraphs.map((paragraph, index) => (
                    <div
                      key={index}
                      className={`transition-all duration-300 w-full text-center text-md md:text-md lg:max-w-lg lg:text-lg 2xl:max-w-4xl font-display 2xl:text-2xl mt-[6px] font-medium ${
                        index === currentParagraph
                          ? "animate-slide-up"
                          : "animationhidden"
                      }`}
                    >
                      {paragraph}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center items-center w-full  bg-white">
            <div className="mt-0 flex flex-col items-center space-y-8   max-w-sm text-sm md:text-lg lg:text-lg 2xl:text-2xl sm:mb-20 md:max-w-2xl lg:max-w-4xl 2xl:max-w-4xl relative font-display">
              <div className="text-center  pb-10 md:pb-0 text-sm max-w-sm md:text-lg md:max-w-2xl lg:max-w-4xl mt-16 md:mt-0  2xl:max-w-8xl lg:text-lg 2xl:text-2xl font-medium leading-relaxed ">
                Without a clear{" "}
                <span className="bg-[#3E59B7]  text-white">
                  understanding of your current state,
                </span>{" "}
                setting realistic goals for digital transformation and{" "}
                <span className="bg-[#3E59B7] text-white ">
                  AI adoption becomes a guessing game.
                </span>{" "}
                This can lead to wasted resources, failed implementations, and
                missed opportunities.
              </div>
            </div>
          </div>
        </div>

        <div id="t2">
          <div className="bg-[#ECEEF8]">
            <div className="items-center justify-center relative overflow-hidden animate-section">
              <div
                className="absolute ball-image bg-[#3E59B7] w-20 h-20   md:w-28 md:h-28 lg:w-32 lg:h-32  2xl: rounded-full z-20 top-12 md:top-20 lg:mt-0 2xl:top-32"
                style={{ left: 0, transition: "none" }}
              ></div>

              <div className="mt-60 md:mt-[340px] lg:mt-[380px] 2xl:mt-[400px] text-center text-animate pb-28">
                <div className="text-3xl md:text-5xl lg:text-6xl lg:mb-3 md:mb-3 2xl:text-8xl text-[#3E59B7] font-display font-bold">
                  Don't take a blind leap
                </div>
                <div className="text-base md:text-lg lg:text-2xl 2xl:text-4xl font-display text-center text-[#3E59B7] font-medium">
                  The Bridge You Need to Turn AI <br />
                  Ambition into Strategy.
                </div>
              </div>

              <img
                src={pinkoval}
                alt="Description"
                className="w-96 h-16 md:w-auto md:h-24 absolute left-0 -ml-10 md:-ml-20 lg:-ml-16 2xl:-ml-20 top-32 md:top-48 lg:top-52 2xl:top-64 z-10 [#FF94CE]-oval"
              />
            </div>
          </div>

          <div className="relative bg-[#FFFFFF] pb-10 overflow-hidden">
            <div id="learn-more-section"></div>
            <img
              src={bubbleleft}
              alt="Bubble"
              className="w-24 h-auto md:w-28 md:h-auto lg:w-32 lg:h-auto 2xl:w-52 2xl:h-auto absolute left-0 top-40 md:top-28 2xl:top-48 -ml-10  md:-ml-7 lg:-ml-10 2xl:-ml-16 transform"
            />

            <img
              src={bubbleright}
              alt="Bubble"
              className="hidden md:block md:w-28 md:h-auto lg:w-28 lg:h-auto  2xl:w-52 2xl:h-auto absolute right-0 top-0 md:top-24 2xl:top-44  lg:top-20 md:-mr-12 lg:-mr-12 2xl:-mr-24 transform"
            />

            <div className="flex flex-col items-center justify-center text-center relative z-10">
              <div className="text-[#230C5A] text-2xl md:text-[45px] lg:text-[60px] 2xl:text-8xl mt-10 md:mt-20 lg:mt-29 2xl:mt-40 font-display font-bold">
                Discover your AI readiness
              </div>

              <div className="text-lg text-[#3E59B7] md:text-3xl lg:text-4xl 2xl:text-5xl mt-4 md:mt-20 lg:mt-28 font-display">
                In just{" "}
                <span className="text-[#3E59B7] font-bold">15 minutes</span>{" "}
                <br /> using our
              </div>

              <div className="text-lg text-[#C62B6D] mt-3 md:text-4xl lg:text-[45px] 2xl:text-7xl font-semibold md:font-medium  md:mt-5 font-display">
                AI Readiness & Digital Maturity <br />
                Assessment Index
              </div>

              <iframe
                src="https://www.youtube.com/embed/g2bGWGtnZuw?autoplay=1&mute=1&loop=1&playlist=g2bGWGtnZuw"
                frameborder="0"
                allowfullscreen
                class="md:w-9/12 md:h-auto w-11/12 h-auto aspect-video rounded-2xl object-contain md:m-12 mb-6 "
                title="AI Readiness Index & Digital Maturity"
              ></iframe>

              <div className="mt-10">
                <button
                  id="scheduling-consultation"
                  type="submit"
                  className="group bg-[#C62B6D] text-button px-10 lg:px-12 py-4 rounded-xl text-white font-display border font-semibold text-sm lg:text-lg shadow-lg flex items-center justify-center hover:bg-[#FFFFFF] hover:text-black  hover:border-black"
                  onClick={handleButtonClick}
                >
                  Schedule Consultation
                  <span className="ml-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="w-6 h-5 group-hover:text-black"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M2 12h20m-7-7 7 7-7 7"
                      />
                    </svg>
                  </span>
                </button>
              </div>

              <img
                src={diamonds3}
                alt="Decorative Image"
                className="hidden md:block absolute  lg:w-auto lg:h-auto  md:-right-4 md:-bottom-[64px] "
              />
            </div>
          </div>

          <div className="relative flex flex-col md:flex-row bg-custom-gradient55 w-full text-center overflow-hidden ">
            <img
              src={diamonds}
              alt="Top Left Image"
              className="hidden md:block absolute top-0 md:w-36 md:h-auto md:-left-10 lg:w-44 lg:h-auto lg:-left-12 2xl:w-48 2xl:h-auto 2xl:-left-12"
            />
            <div className="flex z-10 max-md:flex-col w-full lg:justify-end 2xl:justify-center 2xl:pl-0 lg:mt-10">
              <div className="flex flex-col">
                <div className="text-white  text-xl max-w-80 ml-8 mt-20 text-left md:text-left md:text-xl lg:text-3xl 2xl:text-4xl lg:mt-24 2xl:mt-20 lg:mr-10 md:max-w-lg lg:max-w-lg 2xl:max-w-xl font-bold font-display">
                  Our assessment tool addresses this critical gap by helping you
                  answer essential questions
                </div>
                <div className="flex space-x-2 ml-8 mt-5">
                  <button
                    id="scroll-left"
                    className="flex items-center justify-center w-10 h-10 bg-[#C62B6D] text-[#3E1D9E] font-bold rounded-full border border-none cursor-pointer"
                    onClick={handleScrollLeft}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#FFFFFF"
                      className="w-7 h-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M22 12H2m7-7-7 7 7 7"
                      />
                    </svg>
                  </button>
                  <button
                    id="scroll-right"
                    className="flex items-center justify-center w-10 h-10 bg-[#C62B6D] text-[#3E1D9E] font-bold rounded-full border border-none cursor-pointer"
                    onClick={handleScrollRight}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#FFFFFF"
                      className="w-7 h-5"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M2 12h20m-7-7 7 7-7 7"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              <div
                className="scroll-container overflow-x-auto whitespace-nowrap flex w-full md:max-w-[700px] p-2 md:p-5"
                ref={scrollContainerRef}
              >
                {rectangles.map((rectangle, index) => (
                  <div
                    key={index}
                    className="card flex flex-col bg-white p-4 pr-6 pl-4 rounded-2xl shadow-lg m-2 min-w-[350px] md:min-w-[450px] h-44 md:h-[200px] lg:h-[250px] 2xl:h-[300px] 2xl:min-w-[550px] mb-4 md:mb-6"
                  >
                    <img
                      src={rectangle.imgSrc}
                      alt={`Image ${index + 1}`}
                      className="ml-2 mt-4 w-8 h-8 md:w-12 md:h-12 lg:w-16 lg:h-16 2xl:w-20 2xl:h-20"
                    />
                    <div className="text-sm ml-2 mt-3 lg:text-lg 2xl:text-2xl md:ml-4 md:mt-5 text-left font-display text-wrap min-w-[250px] md:min-w-[350px] lg:min-w-[430px] 2xl:min-w-[500px]">
                      {rectangle.text}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <img
              src={cubebottom}
              alt="Decorative Image"
              className=" md:hidden block w-20 -mt-16 h-auto "
            />
          </div>

          <div className="flex bg-[#CDCBFF] flex-col  md:flex-row space-y-0 lg:space-x-0.5 space-x-0 md:space-y-0 md:space-x-1 w-full md:h-auto md:w-auto md:mt-16 p-0.5 lg:mt-16 2xl:mt-0">
            <div className="flex flex-col items-start border bg-white border-[#CDCBFF]  p-4 md:p-10 lg:p-12 2xl:p-20 flex-1 z-10">
              <img
                src={icon6}
                alt="Image 1"
                className="w-12 h-12 md:w-12 md:h-12 lg:w-16 lg:h-16 2xl:w-20 2xl:h-20"
              />
              <div className="mt-3 ml-2 md:mt-2 text-left">
                <div className="text-black text-sm md:text-sm lg:text-base 2xl:text-2xl font-display">
                  Identifies gaps between your AI aspirations and your current
                  digital capabilities.
                </div>
              </div>
            </div>

            <div className="flex flex-col items-start border bg-white border-[#CDCBFF] p-4 md:p-10 lg:p-12 2xl:p-20 flex-1 z-10">
              <img
                src={icon7}
                alt="Image 2"
                className="w-12 h-12 md:w-12 md:h-12 lg:w-16 lg:h-16 2xl:w-20 2xl:h-20"
              />
              <div className="mt-3 ml-2 md:mt-2 text-left">
                <div className="text-black text-sm md:text-sm lg:text-base 2xl:text-2xl font-display">
                  Provides actionable insights on how to bridge those gaps with
                  a prioritized roadmap.
                </div>
              </div>
            </div>

            <div className="flex flex-col items-start border bg-white border-[#CDCBFF] p-4 md:p-10 lg:p-12 2xl:p-20 flex-1 z-10">
              <img
                src={icon8}
                alt="Image 3"
                className="w-12 h-12 md:w-12 md:h-12 lg:w-16 lg:h-16 2xl:w-20 2xl:h-20"
              />
              <div className="mt-3 ml-2 md:mt-2 text-left">
                <div className="text-black text-sm md:text-sm lg:text-base 2xl:text-2xl font-display">
                  Empowers leaders to make data-driven decisions about AI
                  adoption and digital transformation initiatives.
                </div>
              </div>
            </div>
          </div>

          <div id="business-section">
            <BusinessPage
              onCTAClick10={handleOpenFormLiteracy}
              onCTAClick499={handleOpenForm}
            />
          </div>
        </div>

        <div className=" w-full h-1/2">
          <video
            className="w-full h-auto object-cover"
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={journey} type="video/mp4" />
            Your browser does not support the video.
          </video>
        </div>

        <div id="t3">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4   p-4 md:p-10 lg:p-10   2xl:p-32 mx-auto">
            <div className=" rounded-xl text-3xl md:text-4xl lg:text-5xl 2xl:text-6xl font-display  font-bold p-4 2xl:w-full h-56 md:mx-0 lg:h-64">
              <p>Benefits</p>
              <p>of the tool</p>
              <div className="mt-10">
                <button
                  id="start-now"
                  className="bg-[#C62B6D] text-white px-13 lg:px-10 w-3/4 md:w-4/5 2xl:w-1/2 py-4 rounded-full border-2 border-none  font-display font-semibold text-sm lg:text-xl flex items-center justify-center"
                  onClick={() =>
                    document.getElementById("t4").scrollIntoView({
                      behavior: "smooth",
                    })
                  }
                >
                  Get Started <span className="ml-2">&#8594;</span>
                </button>
              </div>
            </div>
            <div className="border border border-custom rounded-xl p-4 h-56 md:h-72   lg:w-80 xl:w-96 2xl:w-full flex flex-col items-center justify-center text-lg text-center hover:bg-[#C62B6D] hover:text-white hover:border-2">
              <p className="mb-5 text-lg md:text-md lg:text-xl 2xl:text-2xl font-semibold font-display">
                Develop a Strong AI Vision & Strategy
              </p>
              <p className="text-md md:text-sm  lg:text-lg 2xl:text-xl font-display">
                Align AI initiatives with our long-term business goals.
              </p>
            </div>

            <div className="border border border-custom rounded-xl p-4  h-56 md:h-72  lg:w-80 xl:w-96 2xl:w-full flex flex-col items-center justify-center text-lg text-center hover:bg-[#C62B6D] hover:text-white hover:border-2">
              <p className="mb-5 text-lg md:text-md lg:text-xl 2xl:text-2xl font-semibold font-display">
                Identify Strengths & Weaknesses
              </p>
              <p className="text-md md:text-sm  lg:text-lg 2xl:text-xl font-display">
                Uncover areas where you excel and areas needing improvement.
              </p>
            </div>
            <div className="border border border-custom rounded-xl p-4  h-56 md:h-72  lg:w-80 xl:w-96 2xl:w-full  flex flex-col items-center justify-center text-lg text-center hover:bg-[#C62B6D] hover:text-white hover:border-2">
              <p className="mb-5 text-lg md:text-md lg:text-lg 2xl:text-2xl font-semibold font-display">
                Bridge Skills and Gaps
              </p>
              <p className="text-md md:text-sm  lg:text-md 2xl:text-xl font-display">
                Develop or acquire the necessary talent to effectively utilize
                AI.
              </p>
            </div>
            <div className="border border border-custom rounded-xl p-4  h-56 md:h-72 lg:w-80 xl:w-96 2xl:w-full flex flex-col items-center justify-center text-lg text-center hover:bg-[#C62B6D] hover:text-white hover:border-2">
              <p className="mb-5 text-lg md:text-md lg:text-lg 2xl:text-2xl font-semibold font-display">
                Make Data-Driven Decisions
              </p>
              <p className="text-md md:text-sm  lg:text-md 2xl:text-xl font-display">
                Invest in AI solutions that deliver a strong return on
                investment (ROI).
              </p>
            </div>

            <div className="border border border-custom rounded-xl p-4 h-56 md:h-72  lg:w-80 xl:w-96 2xl:w-full flex flex-col items-center justify-center text-lg text-center hover:bg-[#C62B6D] hover:text-white hover:border-2">
              <p className="mb-5 text-lg md:text-md lg:text-xl 2xl:text-2xl font-semibold font-display">
                Optimize Resource Allocation
              </p>
              <p className="text-md md:text-sm  lg:text-md 2xl:text-xl font-display">
                {" "}
                Allocate resources effectively to bridge digital maturity gaps
                and support AI initiatives.
              </p>
            </div>
            <div className="border border border-custom rounded-xl p-4  h-56 md:h-72  lg:w-80 xl:w-96 2xl:w-full flex flex-col items-center justify-center text-lg text-center hover:bg-[#C62B6D] hover:text-white hover:border-2">
              <p className="mb-5 text-lg md:text-md lg:text-lg 2xl:text-2xl font-semibold font-display">
                Uncover Departmental Digital Maturity
              </p>
              <p className="text-md md:text-sm  lg:text-md 2xl:text-xl font-display">
                Identify areas within their departments that are digitally
                advanced or lagging.
              </p>
            </div>
            <div className="border border border-custom rounded-xl p-4  h-56 md:h-72 lg:w-80 xl:w-96 2xl:w-full flex flex-col items-center justify-center text-lg text-center hover:bg-[#C62B6D] hover:text-white hover:border-2">
              <p className="mb-5 text-lg md:text-md lg:text-lg 2xl:text-2xl font-semibold font-display">
                Craft a Transformation Roadmap
              </p>
              <p className="text-md md:text-sm  lg:text-md 2xl:text-xl font-display">
                Develop a clear plan for each department to achieve higher
                digital maturity levels.
              </p>
            </div>
            <div className="border border border-custom rounded-xl p-4  h-56 md:h-72 2xl:w-full  xl:w-96 lg:w-80 flex flex-col items-center justify-center text-lg text-center hover:bg-[#C62B6D] hover:text-white hover:border-2">
              <p className="mb-5 text-lg md:text-md lg:text-lg 2xl:text-2xl font-semibold font-display">
                Prepare for AI Integration{" "}
              </p>
              <p className="text-md md:text-sm  lg:text-md 2xl:text-xl font-display">
                Ensure their departments have the digital foundation necessary
                to leverage AI successfully.
              </p>
            </div>
          </div>
        </div>

        <div id="t4">
          <CTAPage
            CTAClicked10={handleOpenFormLiteracy}
            CTAClicked499={handleOpenForm}
          />
        </div>

        {/* mobile version */}

        {isModalOpen && (
          <div className="fixed z-50 inset-0 md:p-0 p-12 py-10 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="relative bg-white p-8 rounded-lg max-w-md w-full">
              <button
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                onClick={closeModal}
                id="form-close-button"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="4"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
              <div className="text-lg text-black md:text-xl text-center font-bold mb-4">
                Access Your{" "}
                <span className="text-[#C62B6D] font-bold"> AI Readiness </span>
                <br />
                In Just 15 Minutes!
              </div>
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className=" text-gray-700">First Name</label>
                  <input
                    id="first-name"
                    type="text"
                    name="name"
                    value={userName}
                    onChange={(e) => setfirstName(e.target.value)}
                    className="w-full px-3 py-2 border rounded text-black"
                    required
                  />
                  {errors.name && (
                    <p className="text-red-500 text-sm">{errors.name}</p>
                  )}
                </div>

                <div className="mb-4">
                  <label className=" text-gray-700">Last Name</label>
                  <input
                    id="last-name"
                    type="text"
                    name="name"
                    value={lastName}
                    onChange={(e) => setlastName(e.target.value)}
                    className="w-full px-3 py-2 border rounded text-black"
                    required
                  />
                  {errors.name && (
                    <p className="text-red-500 text-sm">{errors.name}</p>
                  )}
                </div>

                <div className="mb-4">
                  <label className=" text-gray-700">Email Address</label>
                  <input
                    id="email-address"
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmailId(e.target.value)}
                    className="w-full px-3 py-2 border rounded  text-black"
                    required
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm">{errors.email}</p>
                  )}
                </div>

                <div className="mb-4">
                  <label className="text-gray-700 text-sm">Phone Number</label>
                  <PhoneInput
                    id="mobile-number"
                    country={"in"}
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    inputClass="custom-phone-input2"
                    buttonClass="border rounded"
                    dropdownClass="border rounded"
                    className="text-black"
                    autocomplete="off"
                    enableSearch={true}
                    inputProps={{
                      required: true,
                      autoFocus: false,
                    }}
                  />
                  {errors.phoneNumber && (
                    <p className="text-red-500 text-sm">{errors.phoneNumber}</p>
                  )}
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700">Designation</label>
                  <input
                    id="job-title"
                    type="text"
                    name="designation"
                    value={designation}
                    onChange={(e) => setDesignation(e.target.value)}
                    className="w-full px-3 py-2 border rounded  text-black"
                    required
                  />
                  {errors.designation && (
                    <p className="text-red-500 text-sm">{errors.designation}</p>
                  )}
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700">Company Name</label>
                  <input
                    id="company-name"
                    type="text"
                    name="companyName"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    className="w-full px-3 py-2 border rounded  text-black"
                    required
                  />
                  {errors.companyName && (
                    <p className="text-red-500 text-sm">{errors.companyName}</p>
                  )}
                </div>

                <div className="flex justify-end">
                  <button
                    id="can-cel"
                    type="button"
                    className="mr-4 px-4 py-2 bg-gray-500 text-white rounded"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    id="forward"
                    type="submit"
                    className="px-4 py-2 bg-[#C62B6D] text-white rounded"
                  >
                    Send
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {isSuccessOpen && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white text-black p-8 rounded-lg max-w-md w-full text-center">
              <h2 className="text-2xl font-bold mb-4">Success!</h2>
              <p className="mb-4">Your request has been sent successfully.</p>
              <button
                id="adjacent"
                className="px-4 py-2 bg-[#C62B6D] text-white rounded"
                onClick={closeSuccessModal}
              >
                Close
              </button>
            </div>
          </div>
        )}

        {/* for Mobile */}
        {isFormOpen && (
          <div className="fixed md:hidden overflow-auto font-display z-50 py-10 px-10 inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white rounded-lg max-w-4xl w-full max-h-full flex flex-col relative overflow-auto">
              <button
                className="absolute top-2 right-2 text-gray-700 hover:text-gray-700"
                onClick={closeModal}
                id="form-close-button"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="4"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
              <div
                className="bg-[#7B53EC] flex flex-col items-center justify-center rounded-t-lg bg-no-repeat bg-cover w-full"
                style={{
                  backgroundImage: `url(${bgimg1})`,
                  backgroundPosition: "center",
                }}
              >
                <div className="flex flex-col items-center justify-center px-10 pt-10">
                  <div className="text-sm font-normal pb-2 text-white text-center">
                    Discover your AI readiness
                  </div>
                  <div className="text-xs font-semibold text-white text-center">
                    AI Readiness & Digital Maturity Assessment Index
                  </div>
                </div>
                <img
                  src={aibg}
                  alt="Description of image"
                  className="w-10/12 h-auto mt-4"
                />
              </div>
              <div className="relative p-4 flex-1">
                <div className="flex justify-center mb-4">
                  <button
                    id="arrow"
                    className="w-8 h-8 bg-[#040330] text-[#3E1D9E] font-bold rounded-full flex items-center justify-center cursor-default"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#FFFFFF"
                      className="w-4 h-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 3v18m-7-7l7 7 7-7"
                      />
                    </svg>
                  </button>
                </div>
                <div className="flex justify-center mb-4 ">
                  <div className="bg-[#C6A4FF] text-white px-4 py-3 inline-block rounded-md">
                    <h2 className="text-md font-semibold font-display  ">
                      For Business
                    </h2>
                  </div>
                </div>
                <div className="text-sm font-normal mb-5  lg:text-xl md:text-sm text-black text-center">
                  Please fill the form to <br /> proceed payment
                </div>

                <form>
                  {step === 1 && (
                    <>
                      <div className="mb-4">
                        <label className=" text-gray-700">
                          First Name{" "}
                          {showStep1Errors && errors.userName && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.userName}
                            </span>
                          )}
                        </label>
                        <input
                          id="first-name-form"
                          type="text"
                          name="userName"
                          value={userName}
                          onChange={(e) => setUserName(e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded text-black"
                        />
                      </div>
                      <div className="mb-4">
                        <label className=" text-gray-700">
                          Last Name
                          {showStep1Errors && errors.lastName && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.lastName}
                            </span>
                          )}
                        </label>
                        <input
                          id="last-name-form"
                          type="text"
                          name="name"
                          value={lastName}
                          onChange={(e) => setlastName(e.target.value)}
                          className="w-full px-3 py-2 border rounded text-black"
                          required
                        />
                      </div>

                      <div className="mb-4">
                        <label className=" text-gray-700 text-sm">
                          Email Address
                          {showStep1Errors && errors.email && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.email}
                            </span>
                          )}
                        </label>
                        <input
                          id="email-form"
                          type="email"
                          name="email"
                          value={email}
                          onChange={(e) => setEmailId(e.target.value)}
                          className="w-full px-3 py-1 border rounded border-gray-300 text-black"
                        />
                      </div>
                      <div className="mb-4">
                        <label className="text-gray-700 text-sm">
                          Phone Number
                          {showStep1Errors && errors.userphoneNumber && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.userphoneNumber}
                            </span>
                          )}
                        </label>
                        <PhoneInput
                          id="phone-number"
                          country={"in"}
                          value={userphoneNumber}
                          onChange={setusersphoneNumber}
                          inputClass="custom-phone-input3"
                          buttonClass="border rounded"
                          dropdownClass="border rounded"
                          className="text-black"
                          autocomplete="off"
                          enableSearch={true}
                          inputProps={{
                            required: true,
                            autoFocus: false,
                          }}
                        />
                      </div>
                      <div className="mb-4">
                        <label className="block text-gray-700 text-sm">
                          Job Title
                          {showStep1Errors && errors.userDesignation && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.userDesignation}
                            </span>
                          )}
                        </label>
                        <input
                          id="designation"
                          type="text"
                          name="userDesignation"
                          value={userDesignation}
                          onChange={(e) => setUserDesignation(e.target.value)}
                          className="w-full px-3 py-1 border rounded border-gray-300 text-black"
                        />
                      </div>
                      <div className="mb-4">
                        <label className="block text-gray-700 text-sm">
                          Company Name
                          {showStep1Errors && errors.userCompanyName && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.userCompanyName}
                            </span>
                          )}
                        </label>
                        <input
                          id="company-name-form"
                          type="text"
                          name="userCompanyName"
                          value={userCompanyName}
                          onChange={(e) => setUserCompanyName(e.target.value)}
                          className="w-full px-3 py-1 border border-gray-300 rounded text-black"
                        />
                      </div>
                      <div className="flex justify-start ">
                        <button
                          id="following"
                          type="button"
                          className="px-4 py-2 text-xs bg-[#19188B] text-white rounded-full"
                          onClick={handleNextClick}
                        >
                          Next
                        </button>
                      </div>
                    </>
                  )}
                  {step === 2 && (
                    <>
                      <h1 className="text-gray-700  text-sm mb-2 ">
                        Billing Address:
                      </h1>
                      <div className="mb-2">
                        <label className="block text-gray-700 text-sm">
                          Street
                          {showStep2Errors && errors.street && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.street}
                            </span>
                          )}
                        </label>
                        <textarea
                          id="text-box"
                          name="street"
                          value={street}
                          onChange={(e) => setstreet(e.target.value)}
                          className="w-full px-3 py-0 border rounded text-black"
                        ></textarea>
                      </div>
                      <div className="flex gap-4 mb-4">
                        <div className="flex-1">
                          <label className="block text-gray-700 text-sm ">
                            City
                            {showStep2Errors && errors.city && (
                              <span className="text-red-500 text-sm ml-2">
                                {errors.city}
                              </span>
                            )}
                          </label>
                          <input
                            id="city-form"
                            type="text"
                            name="city"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            className={`w-full px-3 py-0 border rounded text-black ${
                              zip.length === 6 ? "bg-gray-100" : ""
                            }`}
                            required
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block text-gray-700 text-sm">
                            State
                            {showStep2Errors && errors.state && (
                              <span className="text-red-500 text-sm ml-2">
                                {errors.state}
                              </span>
                            )}
                          </label>
                          <input
                            id="state-name-form"
                            type="text"
                            name="state"
                            value={state}
                            onChange={(e) => setState(e.target.value)}
                            className={`w-full px-3 py-0 border rounded text-black ${
                              zip.length === 6 ? "bg-gray-100" : ""
                            }`}
                            required
                          />
                        </div>
                      </div>

                      <div className="flex gap-4 mb-4">
                        <div className="flex-1">
                          <label className="block text-gray-700 text-sm">
                            Country
                          </label>
                          <select
                            id="country-name-form"
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            className="w-full px-3 py-1 border rounded border-gray-300 text-black"
                          >
                            <option value="">--Select--</option>
                            <option value="AF">Afghanistan</option>
                            <option value="AX">Åland Islands</option>
                            <option value="AL">Albania</option>
                            <option value="DZ">Algeria</option>
                            <option value="AS">American Samoa</option>
                            <option value="AD">Andorra</option>
                            <option value="AO">Angola</option>
                            <option value="AI">Anguilla</option>
                            <option value="AQ">Antarctica</option>
                            <option value="AG">Antigua and Barbuda</option>
                            <option value="AR">Argentina</option>
                            <option value="AM">Armenia</option>
                            <option value="AW">Aruba</option>
                            <option value="AU">Australia</option>
                            <option value="AT">Austria</option>
                            <option value="AZ">Azerbaijan</option>
                            <option value="BS">Bahamas</option>
                            <option value="BH">Bahrain</option>
                            <option value="BD">Bangladesh</option>
                            <option value="BB">Barbados</option>
                            <option value="BY">Belarus</option>
                            <option value="BE">Belgium</option>
                            <option value="BZ">Belize</option>
                            <option value="BJ">Benin</option>
                            <option value="BM">Bermuda</option>
                            <option value="BT">Bhutan</option>
                            <option value="BO">
                              Bolivia, Plurinational State of
                            </option>
                            <option value="BQ">
                              Bonaire, Sint Eustatius and Saba
                            </option>
                            <option value="BA">Bosnia and Herzegovina</option>
                            <option value="BW">Botswana</option>
                            <option value="BV">Bouvet Island</option>
                            <option value="BR">Brazil</option>
                            <option value="IO">
                              British Indian Ocean Territory
                            </option>
                            <option value="BN">Brunei Darussalam</option>
                            <option value="BG">Bulgaria</option>
                            <option value="BF">Burkina Faso</option>
                            <option value="BI">Burundi</option>
                            <option value="KH">Cambodia</option>
                            <option value="CM">Cameroon</option>
                            <option value="CA">Canada</option>
                            <option value="CV">Cape Verde</option>
                            <option value="KY">Cayman Islands</option>
                            <option value="CF">Central African Republic</option>
                            <option value="TD">Chad</option>
                            <option value="CL">Chile</option>
                            <option value="CN">China</option>
                            <option value="CX">Christmas Island</option>
                            <option value="CC">Cocos (Keeling) Islands</option>
                            <option value="CO">Colombia</option>
                            <option value="KM">Comoros</option>
                            <option value="CG">Congo</option>
                            <option value="CD">
                              Congo, the Democratic Republic of the
                            </option>
                            <option value="CK">Cook Islands</option>
                            <option value="CR">Costa Rica</option>
                            <option value="CI">Côte d'Ivoire</option>
                            <option value="HR">Croatia</option>
                            <option value="CU">Cuba</option>
                            <option value="CW">Curaçao</option>
                            <option value="CY">Cyprus</option>
                            <option value="CZ">Czech Republic</option>
                            <option value="DK">Denmark</option>
                            <option value="DJ">Djibouti</option>
                            <option value="DM">Dominica</option>
                            <option value="DO">Dominican Republic</option>
                            <option value="EC">Ecuador</option>
                            <option value="EG">Egypt</option>
                            <option value="SV">El Salvador</option>
                            <option value="GQ">Equatorial Guinea</option>
                            <option value="ER">Eritrea</option>
                            <option value="EE">Estonia</option>
                            <option value="ET">Ethiopia</option>
                            <option value="FK">
                              Falkland Islands (Malvinas)
                            </option>
                            <option value="FO">Faroe Islands</option>
                            <option value="FJ">Fiji</option>
                            <option value="FI">Finland</option>
                            <option value="FR">France</option>
                            <option value="GF">French Guiana</option>
                            <option value="PF">French Polynesia</option>
                            <option value="TF">
                              French Southern Territories
                            </option>
                            <option value="GA">Gabon</option>
                            <option value="GM">Gambia</option>
                            <option value="GE">Georgia</option>
                            <option value="DE">Germany</option>
                            <option value="GH">Ghana</option>
                            <option value="GI">Gibraltar</option>
                            <option value="GR">Greece</option>
                            <option value="GL">Greenland</option>
                            <option value="GD">Grenada</option>
                            <option value="GP">Guadeloupe</option>
                            <option value="GU">Guam</option>
                            <option value="GT">Guatemala</option>
                            <option value="GG">Guernsey</option>
                            <option value="GN">Guinea</option>
                            <option value="GW">Guinea-Bissau</option>
                            <option value="GY">Guyana</option>
                            <option value="HT">Haiti</option>
                            <option value="HM">
                              Heard Island and McDonald Islands
                            </option>
                            <option value="VA">
                              Holy See (Vatican City State)
                            </option>
                            <option value="HN">Honduras</option>
                            <option value="HK">Hong Kong</option>
                            <option value="HU">Hungary</option>
                            <option value="IS">Iceland</option>
                            <option value="IN">India</option>
                            <option value="ID">Indonesia</option>
                            <option value="IR">
                              Iran, Islamic Republic of
                            </option>
                            <option value="IQ">Iraq</option>
                            <option value="IE">Ireland</option>
                            <option value="IM">Isle of Man</option>
                            <option value="IL">Israel</option>
                            <option value="IT">Italy</option>
                            <option value="JM">Jamaica</option>
                            <option value="JP">Japan</option>
                            <option value="JE">Jersey</option>
                            <option value="JO">Jordan</option>
                            <option value="KZ">Kazakhstan</option>
                            <option value="KE">Kenya</option>
                            <option value="KI">Kiribati</option>
                            <option value="KP">
                              Korea, Democratic People's Republic of
                            </option>
                            <option value="KR">Korea, Republic of</option>
                            <option value="KW">Kuwait</option>
                            <option value="KG">Kyrgyzstan</option>
                            <option value="LA">
                              Lao People's Democratic Republic
                            </option>
                            <option value="LV">Latvia</option>
                            <option value="LB">Lebanon</option>
                            <option value="LS">Lesotho</option>
                            <option value="LR">Liberia</option>
                            <option value="LY">Libya</option>
                            <option value="LI">Liechtenstein</option>
                            <option value="LT">Lithuania</option>
                            <option value="LU">Luxembourg</option>
                            <option value="MO">Macao</option>
                            <option value="MK">
                              Macedonia, the former Yugoslav Republic of
                            </option>
                            <option value="MG">Madagascar</option>
                            <option value="MW">Malawi</option>
                            <option value="MY">Malaysia</option>
                            <option value="MV">Maldives</option>
                            <option value="ML">Mali</option>
                            <option value="MT">Malta</option>
                            <option value="MH">Marshall Islands</option>
                            <option value="MQ">Martinique</option>
                            <option value="MR">Mauritania</option>
                            <option value="MU">Mauritius</option>
                            <option value="YT">Mayotte</option>
                            <option value="MX">Mexico</option>
                            <option value="FM">
                              Micronesia, Federated States of
                            </option>
                            <option value="MD">Moldova, Republic of</option>
                            <option value="MC">Monaco</option>
                            <option value="MN">Mongolia</option>
                            <option value="ME">Montenegro</option>
                            <option value="MS">Montserrat</option>
                            <option value="MA">Morocco</option>
                            <option value="MZ">Mozambique</option>
                            <option value="MM">Myanmar</option>
                            <option value="NA">Namibia</option>
                            <option value="NR">Nauru</option>
                            <option value="NP">Nepal</option>
                            <option value="NL">Netherlands</option>
                            <option value="NC">New Caledonia</option>
                            <option value="NZ">New Zealand</option>
                            <option value="NI">Nicaragua</option>
                            <option value="NE">Niger</option>
                            <option value="NG">Nigeria</option>
                            <option value="NU">Niue</option>
                            <option value="NF">Norfolk Island</option>
                            <option value="MP">Northern Mariana Islands</option>
                            <option value="NO">Norway</option>
                            <option value="OM">Oman</option>
                            <option value="PK">Pakistan</option>
                            <option value="PW">Palau</option>
                            <option value="PS">
                              Palestinian Territory, Occupied
                            </option>
                            <option value="PA">Panama</option>
                            <option value="PG">Papua New Guinea</option>
                            <option value="PY">Paraguay</option>
                            <option value="PE">Peru</option>
                            <option value="PH">Philippines</option>
                            <option value="PN">Pitcairn</option>
                            <option value="PL">Poland</option>
                            <option value="PT">Portugal</option>
                            <option value="PR">Puerto Rico</option>
                            <option value="QA">Qatar</option>
                            <option value="RE">Réunion</option>
                            <option value="RO">Romania</option>
                            <option value="RU">Russian Federation</option>
                            <option value="RW">Rwanda</option>
                            <option value="BL">Saint Barthélemy</option>
                            <option value="SH">
                              Saint Helena, Ascension and Tristan da Cunha
                            </option>
                            <option value="KN">Saint Kitts and Nevis</option>
                            <option value="LC">Saint Lucia</option>
                            <option value="MF">
                              Saint Martin (French part)
                            </option>
                            <option value="PM">
                              Saint Pierre and Miquelon
                            </option>
                            <option value="VC">
                              Saint Vincent and the Grenadines
                            </option>
                            <option value="WS">Samoa</option>
                            <option value="SM">San Marino</option>
                            <option value="ST">Sao Tome and Principe</option>
                            <option value="SA">Saudi Arabia</option>
                            <option value="SN">Senegal</option>
                            <option value="RS">Serbia</option>
                            <option value="SC">Seychelles</option>
                            <option value="SL">Sierra Leone</option>
                            <option id="singapore" value="SG">
                              Singapore
                            </option>
                            <option value="SX">
                              Sint Maarten (Dutch part)
                            </option>
                            <option value="SK">Slovakia</option>
                            <option value="SI">Slovenia</option>
                            <option value="SB">Solomon Islands</option>
                            <option value="SO">Somalia</option>
                            <option value="ZA">South Africa</option>
                            <option value="GS">
                              South Georgia and the South Sandwich Islands
                            </option>
                            <option value="SS">South Sudan</option>
                            <option value="ES">Spain</option>
                            <option value="LK">Sri Lanka</option>
                            <option value="SD">Sudan</option>
                            <option value="SR">Suriname</option>
                            <option value="SJ">Svalbard and Jan Mayen</option>
                            <option value="SZ">Swaziland</option>
                            <option value="SE">Sweden</option>
                            <option value="CH">Switzerland</option>
                            <option value="SY">Syrian Arab Republic</option>
                            <option value="TW">
                              Taiwan, Province of China
                            </option>
                            <option value="TJ">Tajikistan</option>
                            <option value="TZ">
                              Tanzania, United Republic of
                            </option>
                            <option value="TH">Thailand</option>
                            <option value="TL">Timor-Leste</option>
                            <option value="TG">Togo</option>
                            <option value="TK">Tokelau</option>
                            <option value="TO">Tonga</option>
                            <option value="TT">Trinidad and Tobago</option>
                            <option value="TN">Tunisia</option>
                            <option value="TR">Turkey</option>
                            <option value="TM">Turkmenistan</option>
                            <option value="TC">Turks and Caicos Islands</option>
                            <option value="TV">Tuvalu</option>
                            <option value="UG">Uganda</option>
                            <option value="UA">Ukraine</option>
                            <option value="AE">United Arab Emirates</option>
                            <option value="GB">United Kingdom</option>
                            <option value="US">United States</option>
                            <option value="UM">
                              United States Minor Outlying Islands
                            </option>
                            <option value="UY">Uruguay</option>
                            <option value="UZ">Uzbekistan</option>
                            <option value="VU">Vanuatu</option>
                            <option value="VE">
                              Venezuela, Bolivarian Republic of
                            </option>
                            <option value="VN">Viet Nam</option>
                            <option value="VG">Virgin Islands, British</option>
                            <option value="VI">Virgin Islands, U.S.</option>
                            <option value="WF">Wallis and Futuna</option>
                            <option value="EH">Western Sahara</option>
                            <option value="YE">Yemen</option>
                            <option value="ZM">Zambia</option>
                            <option value="ZW">Zimbabwe</option>
                          </select>
                          {showStep2Errors && errors.country && (
                            <p className="text-red-500 text-sm">
                              {errors.country}
                            </p>
                          )}
                        </div>
                        <div className="flex-1">
                          <label className="block text-gray-700 text-sm">
                            Postal Code
                          </label>
                          <input
                            id="pin-code"
                            type="text"
                            name="zip"
                            value={zip}
                            onChange={(e) => {
                              const newZip = e.target.value;
                              setzip(newZip);

                              // Auto-fill logic
                              if (newZip.length === 6) {
                                // For Indian postal codes
                                fetchPostalCodeData(newZip).then((data) => {
                                  if (data) {
                                    setCity(data.city);
                                    setState(data.state);
                                    setCountry(data.country);
                                  }
                                });
                              }
                            }}
                            className="w-full px-3 py-0 border rounded text-black"
                            autoComplete="new-password" // Prevent browser autofill
                            required
                          />
                          {showStep2Errors && errors.zip && (
                            <p className="text-red-500 text-sm">{errors.zip}</p>
                          )}
                        </div>
                      </div>
                      <div className="mb-6">
                        <label className="flex items-start space-x-3">
                          <input
                            id="newsletter-checkbox"
                            type="checkbox"
                            defaultChecked={true}
                            className="mt-1 h-4 w-4 text-[#19188B] focus:ring-[#19188B] border-gray-300 rounded"
                          />
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Yes, I’d like to receive AI tips, articles, product
                            updates, and other news from Random Walk. I
                            understand I can unsubscribe anytime.
                          </span>
                        </label>
                      </div>
                      <div className="flex justify-end">
                        <button
                          id="before"
                          type="button"
                          className="mr-4 px-7 py-2 border border-blue-900 text-black rounded-full"
                          onClick={() => {
                            setStep(1);
                            setIsLoadingLiteracy(false); // Reset loading state when going back
                          }}
                        >
                          Back
                        </button>
                        <button
                          id="submit-and-checkout"
                          onClick={handleClickLiteracy}
                          type="submit"
                          disabled={isLoadingLiteracy}
                          className="px-7 py-2 bg-[#19188B] text-xs text-white rounded-full flex items-center justify-center"
                        >
                          {isLoadingLiteracy ? (
                            <>
                              <svg
                                className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                              </svg>
                              Processing...
                            </>
                          ) : (
                            "Submit & Checkout"
                          )}
                        </button>
                      </div>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        )}

        {/* for desktop */}
        {isFormOpen && (
          <div className="fixed max-md:hidden font-display z-50 md:p-10 lg:p-32  inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white rounded-lg  w-full  flex relative  ">
              <button
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                onClick={closeModal}
                id="form-close-button"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="4"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
              <div
                className="bg-[#7B53EC] w-full  flex flex-col items-start justify-center rounded-l-lg bg-no-repeat bg-cover  "
                style={{
                  backgroundImage: `url(${bgimg1})`,
                  backgroundPosition: "center",
                }}
              >
                <div className="flex flex-col items-start justify-center">
                  <div className="text-sm md:text-sm lg:text-2xl 2xl:pt-10  font-normal ml-10 pb-3 text-white text-center">
                    Discover your AI readiness
                  </div>
                  <div className="text-sm font-bold md:text-xs lg:text-xl ml-10 pb-3 text-white text-left">
                    AI Readiness & Digital
                    <br />
                    Maturity Assessment Index
                  </div>
                </div>
                <img
                  src={formpic}
                  alt="Description of image"
                  className="md:w-full  2xl:pb-5  px-5 h-auto"
                />
              </div>

              <button
                id="arrrow-symbol"
                className={`absolute left-1/2 md:top-10 lg:top-24 -translate-x-10 transform flex items-center justify-center md:w-7 md:h-7 lg:w-8 lg:h-8 bg-[#040330] text-[#3E1D9E] font-bold rounded-full cursor-default 
              `}
              >
                {step === 1 ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#FFFFFF"
                    className="md:w-3 md:h-3 lg:w-4 lg:h-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M2 12h20m-7-7 7 7-7 7"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#FFFFFF"
                    className="md:w-3 md:h-3 lg:w-4 lg:h-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M2 12h20m-7-7 7 7-7 7"
                    />
                  </svg>
                )}
              </button>

              <div className=" p-8 w-full  justify-center items-center">
                <div className="flex justify-center mb-4 ">
                  <div className=" bg-[#C6A4FF] absolute top-0 text-white px-4 py-3 inline-block rounded-md">
                    <h2 className="text-lg font-semibold font-display  ">
                      For Business
                    </h2>
                  </div>
                </div>
                <div className=" font-normal mb-2 lg:text-xl md:text-sm text-black text-left mt-10">
                  Please fill the form to proceed payment
                </div>
                <form>
                  {step === 1 && (
                    <>
                      <div className="mb-2">
                        <label className=" text-gray-700">
                          First Name{" "}
                          {showStep1Errors && errors.userName && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.userName}
                            </span>
                          )}
                        </label>
                        <input
                          id="first-name-desktop"
                          type="text"
                          name="userName"
                          value={userName}
                          onChange={(e) => setUserName(e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded text-black"
                        />
                      </div>
                      <div className="mb-2">
                        <label className=" text-gray-700">
                          Last Name
                          {showStep1Errors && errors.lastName && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.lastName}
                            </span>
                          )}
                        </label>
                        <input
                          last-name-desktop
                          type="text"
                          name="name"
                          value={lastName}
                          onChange={(e) => setlastName(e.target.value)}
                          className="w-full px-3 py-2 border rounded text-black"
                          required
                        />
                      </div>

                      <div className="mb-2">
                        <label className=" text-gray-700">
                          Email Address
                          {showStep1Errors && errors.email && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.email}
                            </span>
                          )}
                        </label>
                        <input
                          id="email-desktop"
                          type="email"
                          name="email"
                          value={email}
                          onChange={(e) => setEmailId(e.target.value)}
                          className="w-full px-3 py-2 border rounded border-gray-300 text-black"
                        />
                      </div>
                      <div className="mb-2">
                        <label className="text-gray-700">
                          Phone Number
                          {showStep1Errors && errors.userphoneNumber && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.userphoneNumber}
                            </span>
                          )}
                        </label>
                        <PhoneInput
                          mobile-numer-desktop
                          id="phone-number-desktop"
                          country={"in"}
                          value={userphoneNumber}
                          onChange={setusersphoneNumber}
                          inputClass="custom-phone-input4"
                          buttonClass="border rounded"
                          dropdownClass="border rounded"
                          className="text-black"
                          autocomplete="off"
                          enableSearch={true}
                          inputProps={{
                            required: true,
                            autoFocus: false,
                          }}
                        />
                      </div>
                      <div className="mb-2">
                        <label className=" text-gray-700">
                          Job Title
                          {showStep1Errors && errors.userDesignation && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.userDesignation}
                            </span>
                          )}
                        </label>
                        <input
                          id="job-name"
                          type="text"
                          name="userDesignation"
                          value={userDesignation}
                          onChange={(e) => setUserDesignation(e.target.value)}
                          className="w-full px-3 py-2 border rounded border-gray-300 text-black"
                        />
                      </div>
                      <div className="mb-2">
                        <label className=" text-gray-700">
                          Company Name
                          {showStep1Errors && errors.userCompanyName && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.userCompanyName}
                            </span>
                          )}
                        </label>
                        <input
                          id="name-of-the-company"
                          type="text"
                          name="userCompanyName"
                          value={userCompanyName}
                          onChange={(e) => setUserCompanyName(e.target.value)}
                          className="w-full px-3 py-2 border rounded border-gray-300 text-black"
                        />
                      </div>
                      <div className="flex justify-start">
                        <button
                          id="after"
                          type="button"
                          className="px-7 py-2 bg-[#19188B] text-white rounded-full"
                          onClick={handleNextClick}
                        >
                          Next
                        </button>
                      </div>
                    </>
                  )}
                  {step === 2 && (
                    <>
                      <h1 className="text-gray-700 text-base ">
                        Billing Address:
                      </h1>
                      <div className="mb-4">
                        <label className="block text-gray-700">Street</label>
                        <textarea
                          id="street-name"
                          name="street"
                          value={street}
                          onChange={(e) => setstreet(e.target.value)}
                          className="w-full px-3 py-0 border rounded border-gray-300 text-black"
                        ></textarea>
                        {showStep2Errors && errors.street && (
                          <p className="text-red-500 text-sm">
                            {errors.street}
                          </p>
                        )}
                      </div>
                      <div className="flex gap-4 mb-4">
                        <div className="flex-1">
                          <label className="block text-gray-700 text-sm ">
                            City
                            {showStep2Errors && errors.city && (
                              <span className="text-red-500 text-sm ml-2">
                                {errors.city}
                              </span>
                            )}
                          </label>
                          <input
                            id="city-form"
                            type="text"
                            name="city"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            className={`w-full px-3 py-0 border rounded text-black ${
                              zip.length === 6 ? "bg-gray-100" : ""
                            }`}
                            required
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block text-gray-700 text-sm">
                            State
                            {showStep2Errors && errors.state && (
                              <span className="text-red-500 text-sm ml-2">
                                {errors.state}
                              </span>
                            )}
                          </label>
                          <input
                            id="state-name-form"
                            type="text"
                            name="state"
                            value={state}
                            onChange={(e) => setState(e.target.value)}
                            className={`w-full px-3 py-0 border rounded text-black ${
                              zip.length === 6 ? "bg-gray-100" : ""
                            }`}
                            required
                          />
                        </div>
                      </div>

                      <div className="flex gap-4 mb-4">
                        <div className="flex-1 text-black ">
                          <label className="block text-gray-700">Country</label>
                          <select
                            id="country-name"
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            className="w-full px-3 py-1 border rounded border-gray-300 text-black"
                          >
                            <option value="">--Select--</option>
                            <option value="AF">Afghanistan</option>
                            <option value="AX">Åland Islands</option>
                            <option value="AL">Albania</option>
                            <option value="DZ">Algeria</option>
                            <option value="AS">American Samoa</option>
                            <option value="AD">Andorra</option>
                            <option value="AO">Angola</option>
                            <option value="AI">Anguilla</option>
                            <option value="AQ">Antarctica</option>
                            <option value="AG">Antigua and Barbuda</option>
                            <option value="AR">Argentina</option>
                            <option value="AM">Armenia</option>
                            <option value="AW">Aruba</option>
                            <option value="AU">Australia</option>
                            <option value="AT">Austria</option>
                            <option value="AZ">Azerbaijan</option>
                            <option value="BS">Bahamas</option>
                            <option value="BH">Bahrain</option>
                            <option value="BD">Bangladesh</option>
                            <option value="BB">Barbados</option>
                            <option value="BY">Belarus</option>
                            <option value="BE">Belgium</option>
                            <option value="BZ">Belize</option>
                            <option value="BJ">Benin</option>
                            <option value="BM">Bermuda</option>
                            <option value="BT">Bhutan</option>
                            <option value="BO">
                              Bolivia, Plurinational State of
                            </option>
                            <option value="BQ">
                              Bonaire, Sint Eustatius and Saba
                            </option>
                            <option value="BA">Bosnia and Herzegovina</option>
                            <option value="BW">Botswana</option>
                            <option value="BV">Bouvet Island</option>
                            <option value="BR">Brazil</option>
                            <option value="IO">
                              British Indian Ocean Territory
                            </option>
                            <option value="BN">Brunei Darussalam</option>
                            <option value="BG">Bulgaria</option>
                            <option value="BF">Burkina Faso</option>
                            <option value="BI">Burundi</option>
                            <option value="KH">Cambodia</option>
                            <option value="CM">Cameroon</option>
                            <option value="CA">Canada</option>
                            <option value="CV">Cape Verde</option>
                            <option value="KY">Cayman Islands</option>
                            <option value="CF">Central African Republic</option>
                            <option value="TD">Chad</option>
                            <option value="CL">Chile</option>
                            <option value="CN">China</option>
                            <option value="CX">Christmas Island</option>
                            <option value="CC">Cocos (Keeling) Islands</option>
                            <option value="CO">Colombia</option>
                            <option value="KM">Comoros</option>
                            <option value="CG">Congo</option>
                            <option value="CD">
                              Congo, the Democratic Republic of the
                            </option>
                            <option value="CK">Cook Islands</option>
                            <option value="CR">Costa Rica</option>
                            <option value="CI">Côte d'Ivoire</option>
                            <option value="HR">Croatia</option>
                            <option value="CU">Cuba</option>
                            <option value="CW">Curaçao</option>
                            <option value="CY">Cyprus</option>
                            <option value="CZ">Czech Republic</option>
                            <option value="DK">Denmark</option>
                            <option value="DJ">Djibouti</option>
                            <option value="DM">Dominica</option>
                            <option value="DO">Dominican Republic</option>
                            <option value="EC">Ecuador</option>
                            <option value="EG">Egypt</option>
                            <option value="SV">El Salvador</option>
                            <option value="GQ">Equatorial Guinea</option>
                            <option value="ER">Eritrea</option>
                            <option value="EE">Estonia</option>
                            <option value="ET">Ethiopia</option>
                            <option value="FK">
                              Falkland Islands (Malvinas)
                            </option>
                            <option value="FO">Faroe Islands</option>
                            <option value="FJ">Fiji</option>
                            <option value="FI">Finland</option>
                            <option value="FR">France</option>
                            <option value="GF">French Guiana</option>
                            <option value="PF">French Polynesia</option>
                            <option value="TF">
                              French Southern Territories
                            </option>
                            <option value="GA">Gabon</option>
                            <option value="GM">Gambia</option>
                            <option value="GE">Georgia</option>
                            <option value="DE">Germany</option>
                            <option value="GH">Ghana</option>
                            <option value="GI">Gibraltar</option>
                            <option value="GR">Greece</option>
                            <option value="GL">Greenland</option>
                            <option value="GD">Grenada</option>
                            <option value="GP">Guadeloupe</option>
                            <option value="GU">Guam</option>
                            <option value="GT">Guatemala</option>
                            <option value="GG">Guernsey</option>
                            <option value="GN">Guinea</option>
                            <option value="GW">Guinea-Bissau</option>
                            <option value="GY">Guyana</option>
                            <option value="HT">Haiti</option>
                            <option value="HM">
                              Heard Island and McDonald Islands
                            </option>
                            <option value="VA">
                              Holy See (Vatican City State)
                            </option>
                            <option value="HN">Honduras</option>
                            <option value="HK">Hong Kong</option>
                            <option value="HU">Hungary</option>
                            <option value="IS">Iceland</option>
                            <option value="IN">India</option>
                            <option value="ID">Indonesia</option>
                            <option value="IR">
                              Iran, Islamic Republic of
                            </option>
                            <option value="IQ">Iraq</option>
                            <option value="IE">Ireland</option>
                            <option value="IM">Isle of Man</option>
                            <option value="IL">Israel</option>
                            <option value="IT">Italy</option>
                            <option value="JM">Jamaica</option>
                            <option value="JP">Japan</option>
                            <option value="JE">Jersey</option>
                            <option value="JO">Jordan</option>
                            <option value="KZ">Kazakhstan</option>
                            <option value="KE">Kenya</option>
                            <option value="KI">Kiribati</option>
                            <option value="KP">
                              Korea, Democratic People's Republic of
                            </option>
                            <option value="KR">Korea, Republic of</option>
                            <option value="KW">Kuwait</option>
                            <option value="KG">Kyrgyzstan</option>
                            <option value="LA">
                              Lao People's Democratic Republic
                            </option>
                            <option value="LV">Latvia</option>
                            <option value="LB">Lebanon</option>
                            <option value="LS">Lesotho</option>
                            <option value="LR">Liberia</option>
                            <option value="LY">Libya</option>
                            <option value="LI">Liechtenstein</option>
                            <option value="LT">Lithuania</option>
                            <option value="LU">Luxembourg</option>
                            <option value="MO">Macao</option>
                            <option value="MK">
                              Macedonia, the former Yugoslav Republic of
                            </option>
                            <option value="MG">Madagascar</option>
                            <option value="MW">Malawi</option>
                            <option value="MY">Malaysia</option>
                            <option value="MV">Maldives</option>
                            <option value="ML">Mali</option>
                            <option value="MT">Malta</option>
                            <option value="MH">Marshall Islands</option>
                            <option value="MQ">Martinique</option>
                            <option value="MR">Mauritania</option>
                            <option value="MU">Mauritius</option>
                            <option value="YT">Mayotte</option>
                            <option value="MX">Mexico</option>
                            <option value="FM">
                              Micronesia, Federated States of
                            </option>
                            <option value="MD">Moldova, Republic of</option>
                            <option value="MC">Monaco</option>
                            <option value="MN">Mongolia</option>
                            <option value="ME">Montenegro</option>
                            <option value="MS">Montserrat</option>
                            <option value="MA">Morocco</option>
                            <option value="MZ">Mozambique</option>
                            <option value="MM">Myanmar</option>
                            <option value="NA">Namibia</option>
                            <option value="NR">Nauru</option>
                            <option value="NP">Nepal</option>
                            <option value="NL">Netherlands</option>
                            <option value="NC">New Caledonia</option>
                            <option value="NZ">New Zealand</option>
                            <option value="NI">Nicaragua</option>
                            <option value="NE">Niger</option>
                            <option value="NG">Nigeria</option>
                            <option value="NU">Niue</option>
                            <option value="NF">Norfolk Island</option>
                            <option value="MP">Northern Mariana Islands</option>
                            <option value="NO">Norway</option>
                            <option value="OM">Oman</option>
                            <option value="PK">Pakistan</option>
                            <option value="PW">Palau</option>
                            <option value="PS">
                              Palestinian Territory, Occupied
                            </option>
                            <option value="PA">Panama</option>
                            <option value="PG">Papua New Guinea</option>
                            <option value="PY">Paraguay</option>
                            <option value="PE">Peru</option>
                            <option value="PH">Philippines</option>
                            <option value="PN">Pitcairn</option>
                            <option value="PL">Poland</option>
                            <option value="PT">Portugal</option>
                            <option value="PR">Puerto Rico</option>
                            <option value="QA">Qatar</option>
                            <option value="RE">Réunion</option>
                            <option value="RO">Romania</option>
                            <option value="RU">Russian Federation</option>
                            <option value="RW">Rwanda</option>
                            <option value="BL">Saint Barthélemy</option>
                            <option value="SH">
                              Saint Helena, Ascension and Tristan da Cunha
                            </option>
                            <option value="KN">Saint Kitts and Nevis</option>
                            <option value="LC">Saint Lucia</option>
                            <option value="MF">
                              Saint Martin (French part)
                            </option>
                            <option value="PM">
                              Saint Pierre and Miquelon
                            </option>
                            <option value="VC">
                              Saint Vincent and the Grenadines
                            </option>
                            <option value="WS">Samoa</option>
                            <option value="SM">San Marino</option>
                            <option value="ST">Sao Tome and Principe</option>
                            <option value="SA">Saudi Arabia</option>
                            <option value="SN">Senegal</option>
                            <option value="RS">Serbia</option>
                            <option value="SC">Seychelles</option>
                            <option value="SL">Sierra Leone</option>
                            <option id="singapore" value="SG">
                              Singapore
                            </option>
                            <option value="SX">
                              Sint Maarten (Dutch part)
                            </option>
                            <option value="SK">Slovakia</option>
                            <option value="SI">Slovenia</option>
                            <option value="SB">Solomon Islands</option>
                            <option value="SO">Somalia</option>
                            <option value="ZA">South Africa</option>
                            <option value="GS">
                              South Georgia and the South Sandwich Islands
                            </option>
                            <option value="SS">South Sudan</option>
                            <option value="ES">Spain</option>
                            <option value="LK">Sri Lanka</option>
                            <option value="SD">Sudan</option>
                            <option value="SR">Suriname</option>
                            <option value="SJ">Svalbard and Jan Mayen</option>
                            <option value="SZ">Swaziland</option>
                            <option value="SE">Sweden</option>
                            <option value="CH">Switzerland</option>
                            <option value="SY">Syrian Arab Republic</option>
                            <option value="TW">
                              Taiwan, Province of China
                            </option>
                            <option value="TJ">Tajikistan</option>
                            <option value="TZ">
                              Tanzania, United Republic of
                            </option>
                            <option value="TH">Thailand</option>
                            <option value="TL">Timor-Leste</option>
                            <option value="TG">Togo</option>
                            <option value="TK">Tokelau</option>
                            <option value="TO">Tonga</option>
                            <option value="TT">Trinidad and Tobago</option>
                            <option value="TN">Tunisia</option>
                            <option value="TR">Turkey</option>
                            <option value="TM">Turkmenistan</option>
                            <option value="TC">Turks and Caicos Islands</option>
                            <option value="TV">Tuvalu</option>
                            <option value="UG">Uganda</option>
                            <option value="UA">Ukraine</option>
                            <option value="AE">United Arab Emirates</option>
                            <option value="GB">United Kingdom</option>
                            <option value="US">United States</option>
                            <option value="UM">
                              United States Minor Outlying Islands
                            </option>
                            <option value="UY">Uruguay</option>
                            <option value="UZ">Uzbekistan</option>
                            <option value="VU">Vanuatu</option>
                            <option value="VE">
                              Venezuela, Bolivarian Republic of
                            </option>
                            <option value="VN">Viet Nam</option>
                            <option value="VG">Virgin Islands, British</option>
                            <option value="VI">Virgin Islands, U.S.</option>
                            <option value="WF">Wallis and Futuna</option>
                            <option value="EH">Western Sahara</option>
                            <option value="YE">Yemen</option>
                            <option value="ZM">Zambia</option>
                            <option value="ZW">Zimbabwe</option>
                          </select>
                          {showStep2Errors && errors.country && (
                            <p className="text-red-500 text-sm">
                              {errors.country}
                            </p>
                          )}
                        </div>
                        <div className="flex-1">
                          <label className="block text-gray-700 text-sm">
                            Postal Code
                          </label>
                          <input
                            id="pin-code"
                            type="text"
                            name="zip"
                            value={zip}
                            onChange={(e) => {
                              const newZip = e.target.value;
                              setzip(newZip);

                              // Auto-fill logic
                              if (newZip.length === 6) {
                                // For Indian postal codes
                                fetchPostalCodeData(newZip).then((data) => {
                                  if (data) {
                                    setCity(data.city);
                                    setState(data.state);
                                    setCountry(data.country);
                                  }
                                });
                              }
                            }}
                            className="w-full px-3 py-0.5 border rounded text-black"
                            autoComplete="new-password" // Prevent browser autofill
                            required
                          />
                          {showStep2Errors && errors.zip && (
                            <p className="text-red-500 text-sm">{errors.zip}</p>
                          )}
                        </div>
                      </div>
                      <div className="mb-6">
                        <label className="flex items-start space-x-3">
                          <input
                            id="newsletter-checkbox"
                            type="checkbox"
                            defaultChecked={true}
                            className="mt-1 h-4 w-4 text-[#19188B] focus:ring-[#19188B] border-gray-300 rounded"
                          />
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Yes, I’d like to receive AI tips, articles, product
                            updates, and other news from Random Walk. I
                            understand I can unsubscribe anytime.
                          </span>
                        </label>
                      </div>
                      <div className="flex justify-end">
                        <button
                          id="before"
                          type="button"
                          className="mr-4 px-7 py-2  border border-blue-900 text-black rounded-full"
                          onClick={() => setStep(1)}
                        >
                          Back
                        </button>
                        <button
                          id="submit-and-checkout"
                          onClick={handleClick}
                          type="submit"
                          disabled={isLoadingCheckout}
                          className="px-7 py-2 bg-[#19188B] text-white rounded-full flex items-center justify-center"
                        >
                          {isLoadingCheckout ? (
                            <>
                              <svg
                                className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                              </svg>
                              Processing...
                            </>
                          ) : (
                            "Submit & Checkout"
                          )}
                        </button>
                      </div>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        )}

        {/* mobile version */}
        {pageFullyLoaded && isLiteracyFormOpen && (
          <div className="fixed md:hidden font-display z-50 py-10 px-10 inset-0 bg-black bg-opacity-50 flex items-center justify-center overflow-auto">
            <div className="bg-white rounded-lg max-w-4xl w-full max-h-full flex flex-col relative overflow-auto">
              <button
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                onClick={closeModal}
                id="form-close-button"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="4"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
              <div
                className="bg-[#C6A4FF] flex flex-col items-center justify-center rounded-t-lg bg-no-repeat bg-cover w-full"
                style={{
                  backgroundImage: `url(${bgimg1})`,
                  backgroundPosition: "center",
                }}
              >
                <div className="flex flex-col items-center justify-center px-10 pt-10">
                  <div className="text-sm font-normal pb-2 text-white text-center">
                    Discover your AI Literacy
                  </div>
                  <div className="text-xs font-semibold text-white text-center">
                    AI Literacy Assessment
                  </div>
                </div>
                <img
                  src={libg}
                  alt="Description of image"
                  className="w-auto mx-auto h-80 object-contain mt-4"
                />
              </div>
              <div className="relative p-4 flex-1">
                <div className="flex justify-center mb-4">
                  <button
                    id="arrow"
                    className="w-8 h-8 bg-[#040330] text-[#3E1D9E] font-bold rounded-full flex items-center justify-center cursor-default"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#FFFFFF"
                      className="w-4 h-4"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 3v18m-7-7l7 7 7-7"
                      />
                    </svg>
                  </button>
                </div>
                <div className="flex justify-center mb-4 ">
                  <div className="bg-[#C6A4FF] text-white px-4 py-3 inline-block rounded-md">
                    <h2 className="text-lg font-semibold font-display  ">
                      For Individuals
                    </h2>
                  </div>
                </div>
                <div className="text-sm font-normal mb-5  lg:text-xl md:text-sm text-black text-center">
                  Please fill the form to <br /> proceed payment
                </div>

                <form>
                  {step === 1 && (
                    <>
                      <div className="mb-4">
                        <label className=" text-gray-700">
                          First Name{" "}
                          {showStep1Errors && errors.userName && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.userName}
                            </span>
                          )}
                        </label>
                        <input
                          id="first-name-form"
                          type="text"
                          name="userName"
                          value={userName}
                          onChange={(e) => setUserName(e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded text-black"
                        />
                      </div>
                      <div className="mb-4">
                        <label className=" text-gray-700">
                          Last Name
                          {showStep1Errors && errors.lastName && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.lastName}
                            </span>
                          )}
                        </label>
                        <input
                          id="last-name-form"
                          type="text"
                          name="name"
                          value={lastName}
                          onChange={(e) => setlastName(e.target.value)}
                          className="w-full px-3 py-2 border rounded text-black"
                          required
                        />
                      </div>
                      <div className="mb-4">
                        <label className=" text-gray-700 text-sm">
                          Email Address
                          {showStep1Errors && errors.email && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.email}
                            </span>
                          )}
                        </label>
                        <input
                          id="email-form"
                          type="email"
                          name="email"
                          value={email}
                          onChange={(e) => setEmailId(e.target.value)}
                          className="w-full px-3 py-1 border rounded border-gray-300 text-black"
                        />
                      </div>

                      <div className="mb-4">
                        <label className="text-gray-700 text-sm">
                          Phone Number
                          {showStep1Errors && errors.userphoneNumber && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.userphoneNumber}
                            </span>
                          )}
                        </label>
                        <PhoneInput
                          id="phone-number" // This ID is for the wrapper, good for a label's `htmlFor`
                          country={"in"}
                          value={userphoneNumber}
                          onChange={setusersphoneNumber}
                          inputClass="custom-phone-input3" // Styles the actual input
                          buttonClass="border rounded" // Styles the dropdown button
                          dropdownClass="border rounded" // Styles the dropdown list
                          className="text-black" // Styles the main wrapper div of PhoneInput
                          autocomplete="off"
                          inputProps={{
                            // Pass props directly to the <input type="tel"> element
                            name: "userphoneNumber", // Good for form submission if not handled by state
                            required: true, // Example: if it's required
                            onFocus: (event) => {
                              // event.target is the actual <input type="tel"> element
                              // A small timeout can help ensure the keyboard is fully visible
                              // and the layout has adjusted before scrolling.
                              setTimeout(() => {
                                event.target.scrollIntoView({
                                  behavior: "smooth",
                                  block: "center", // Tries to center the input in the viewport
                                  // You can also try 'nearest' or 'start'
                                });
                              }, 100); // Adjust timeout if needed, 0 might also work
                            },
                            // If you need a specific ID on the input itself:
                            // id: "actual-phone-input-field"
                          }}
                        />
                      </div>

                      <div className="mb-4">
                        <label className=" text-gray-700 text-sm">
                          Job Title
                          {showStep1Errors && errors.jobTitle && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.jobTitle}
                            </span>
                          )}
                        </label>
                        <input
                          job-title-desktop
                          type="text"
                          name="jobTitle"
                          value={jobTitle}
                          onChange={(e) => setjobTtitle(e.target.value)}
                          className="w-full px-3 py-2 border rounded text-black"
                          required
                        />
                      </div>
                      <div className="mb-4">
                        <label className="text-gray-700 text-sm">
                          Company Name
                          {showStep1Errors && errors.literacycompanyName && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.literacycompanyName}
                            </span>
                          )}
                        </label>
                        <input
                          literacy-company-name-desktop
                          type="text"
                          name="literacycompanyName"
                          value={literacycompanyName}
                          onChange={(e) =>
                            setLiteracyCompanyName(e.target.value)
                          }
                          className="w-full px-3 py-2 border rounded border-gray-300 text-black"
                          required
                        />
                      </div>
                      <div className="flex justify-start ">
                        <button
                          id="following"
                          type="button"
                          className="px-4 py-2 text-xs bg-[#19188B] text-white rounded-full"
                          onClick={handleNextClick}
                        >
                          Next
                        </button>
                      </div>
                    </>
                  )}
                  {step === 2 && (
                    <>
                      <h1 className="text-gray-700  text-sm mb-2 ">
                        Billing Address:
                      </h1>
                      <div className="mb-2">
                        <label className="block text-gray-700 text-sm">
                          Street
                          {showStep2Errors && errors.street && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.street}
                            </span>
                          )}
                        </label>
                        <textarea
                          id="text-box"
                          name="street"
                          value={street}
                          onChange={(e) => setstreet(e.target.value)}
                          className="w-full px-3 py-0 border rounded text-black"
                        ></textarea>
                      </div>
                      <div className="flex gap-4 mb-4">
                        <div className="flex-1">
                          <label className="block text-gray-700 text-sm ">
                            City
                            {showStep2Errors && errors.city && (
                              <span className="text-red-500 text-sm ml-2">
                                {errors.city}
                              </span>
                            )}
                          </label>
                          <input
                            id="city-form"
                            type="text"
                            name="city"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            className={`w-full px-3 py-0 border rounded text-black ${
                              zip.length === 6 ? "bg-gray-100" : ""
                            }`}
                            required
                          />
                        </div>

                        <div className="flex-1">
                          <label className="block text-gray-700 text-sm">
                            State
                            {showStep2Errors && errors.state && (
                              <span className="text-red-500 text-sm ml-2">
                                {errors.state}
                              </span>
                            )}
                          </label>
                          <input
                            id="state-name-form"
                            type="text"
                            name="state"
                            value={state}
                            onChange={(e) => setState(e.target.value)}
                            className={`w-full px-3 py-0 border rounded text-black ${
                              zip.length === 6 ? "bg-gray-100" : ""
                            }`}
                            required
                          />
                        </div>
                      </div>

                      <div className="flex gap-4 mb-4">
                        <div className="flex-1">
                          <label className="block text-gray-700 text-sm">
                            Country
                          </label>
                          <select
                            id="country-name-form"
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            className="w-full px-3 py-1 border rounded border-gray-300 text-black"
                            required
                          >
                            <option value="">--Select--</option>
                            <option value="AF">Afghanistan</option>
                            <option value="AX">Åland Islands</option>
                            <option value="AL">Albania</option>
                            <option value="DZ">Algeria</option>
                            <option value="AS">American Samoa</option>
                            <option value="AD">Andorra</option>
                            <option value="AO">Angola</option>
                            <option value="AI">Anguilla</option>
                            <option value="AQ">Antarctica</option>
                            <option value="AG">Antigua and Barbuda</option>
                            <option value="AR">Argentina</option>
                            <option value="AM">Armenia</option>
                            <option value="AW">Aruba</option>
                            <option value="AU">Australia</option>
                            <option value="AT">Austria</option>
                            <option value="AZ">Azerbaijan</option>
                            <option value="BS">Bahamas</option>
                            <option value="BH">Bahrain</option>
                            <option value="BD">Bangladesh</option>
                            <option value="BB">Barbados</option>
                            <option value="BY">Belarus</option>
                            <option value="BE">Belgium</option>
                            <option value="BZ">Belize</option>
                            <option value="BJ">Benin</option>
                            <option value="BM">Bermuda</option>
                            <option value="BT">Bhutan</option>
                            <option value="BO">
                              Bolivia, Plurinational State of
                            </option>
                            <option value="BQ">
                              Bonaire, Sint Eustatius and Saba
                            </option>
                            <option value="BA">Bosnia and Herzegovina</option>
                            <option value="BW">Botswana</option>
                            <option value="BV">Bouvet Island</option>
                            <option value="BR">Brazil</option>
                            <option value="IO">
                              British Indian Ocean Territory
                            </option>
                            <option value="BN">Brunei Darussalam</option>
                            <option value="BG">Bulgaria</option>
                            <option value="BF">Burkina Faso</option>
                            <option value="BI">Burundi</option>
                            <option value="KH">Cambodia</option>
                            <option value="CM">Cameroon</option>
                            <option value="CA">Canada</option>
                            <option value="CV">Cape Verde</option>
                            <option value="KY">Cayman Islands</option>
                            <option value="CF">Central African Republic</option>
                            <option value="TD">Chad</option>
                            <option value="CL">Chile</option>
                            <option value="CN">China</option>
                            <option value="CX">Christmas Island</option>
                            <option value="CC">Cocos (Keeling) Islands</option>
                            <option value="CO">Colombia</option>
                            <option value="KM">Comoros</option>
                            <option value="CG">Congo</option>
                            <option value="CD">
                              Congo, the Democratic Republic of the
                            </option>
                            <option value="CK">Cook Islands</option>
                            <option value="CR">Costa Rica</option>
                            <option value="CI">Côte d'Ivoire</option>
                            <option value="HR">Croatia</option>
                            <option value="CU">Cuba</option>
                            <option value="CW">Curaçao</option>
                            <option value="CY">Cyprus</option>
                            <option value="CZ">Czech Republic</option>
                            <option value="DK">Denmark</option>
                            <option value="DJ">Djibouti</option>
                            <option value="DM">Dominica</option>
                            <option value="DO">Dominican Republic</option>
                            <option value="EC">Ecuador</option>
                            <option value="EG">Egypt</option>
                            <option value="SV">El Salvador</option>
                            <option value="GQ">Equatorial Guinea</option>
                            <option value="ER">Eritrea</option>
                            <option value="EE">Estonia</option>
                            <option value="ET">Ethiopia</option>
                            <option value="FK">
                              Falkland Islands (Malvinas)
                            </option>
                            <option value="FO">Faroe Islands</option>
                            <option value="FJ">Fiji</option>
                            <option value="FI">Finland</option>
                            <option value="FR">France</option>
                            <option value="GF">French Guiana</option>
                            <option value="PF">French Polynesia</option>
                            <option value="TF">
                              French Southern Territories
                            </option>
                            <option value="GA">Gabon</option>
                            <option value="GM">Gambia</option>
                            <option value="GE">Georgia</option>
                            <option value="DE">Germany</option>
                            <option value="GH">Ghana</option>
                            <option value="GI">Gibraltar</option>
                            <option value="GR">Greece</option>
                            <option value="GL">Greenland</option>
                            <option value="GD">Grenada</option>
                            <option value="GP">Guadeloupe</option>
                            <option value="GU">Guam</option>
                            <option value="GT">Guatemala</option>
                            <option value="GG">Guernsey</option>
                            <option value="GN">Guinea</option>
                            <option value="GW">Guinea-Bissau</option>
                            <option value="GY">Guyana</option>
                            <option value="HT">Haiti</option>
                            <option value="HM">
                              Heard Island and McDonald Islands
                            </option>
                            <option value="VA">
                              Holy See (Vatican City State)
                            </option>
                            <option value="HN">Honduras</option>
                            <option value="HK">Hong Kong</option>
                            <option value="HU">Hungary</option>
                            <option value="IS">Iceland</option>
                            <option value="IN">India</option>
                            <option value="ID">Indonesia</option>
                            <option value="IR">
                              Iran, Islamic Republic of
                            </option>
                            <option value="IQ">Iraq</option>
                            <option value="IE">Ireland</option>
                            <option value="IM">Isle of Man</option>
                            <option value="IL">Israel</option>
                            <option value="IT">Italy</option>
                            <option value="JM">Jamaica</option>
                            <option value="JP">Japan</option>
                            <option value="JE">Jersey</option>
                            <option value="JO">Jordan</option>
                            <option value="KZ">Kazakhstan</option>
                            <option value="KE">Kenya</option>
                            <option value="KI">Kiribati</option>
                            <option value="KP">
                              Korea, Democratic People's Republic of
                            </option>
                            <option value="KR">Korea, Republic of</option>
                            <option value="KW">Kuwait</option>
                            <option value="KG">Kyrgyzstan</option>
                            <option value="LA">
                              Lao People's Democratic Republic
                            </option>
                            <option value="LV">Latvia</option>
                            <option value="LB">Lebanon</option>
                            <option value="LS">Lesotho</option>
                            <option value="LR">Liberia</option>
                            <option value="LY">Libya</option>
                            <option value="LI">Liechtenstein</option>
                            <option value="LT">Lithuania</option>
                            <option value="LU">Luxembourg</option>
                            <option value="MO">Macao</option>
                            <option value="MK">
                              Macedonia, the former Yugoslav Republic of
                            </option>
                            <option value="MG">Madagascar</option>
                            <option value="MW">Malawi</option>
                            <option value="MY">Malaysia</option>
                            <option value="MV">Maldives</option>
                            <option value="ML">Mali</option>
                            <option value="MT">Malta</option>
                            <option value="MH">Marshall Islands</option>
                            <option value="MQ">Martinique</option>
                            <option value="MR">Mauritania</option>
                            <option value="MU">Mauritius</option>
                            <option value="YT">Mayotte</option>
                            <option value="MX">Mexico</option>
                            <option value="FM">
                              Micronesia, Federated States of
                            </option>
                            <option value="MD">Moldova, Republic of</option>
                            <option value="MC">Monaco</option>
                            <option value="MN">Mongolia</option>
                            <option value="ME">Montenegro</option>
                            <option value="MS">Montserrat</option>
                            <option value="MA">Morocco</option>
                            <option value="MZ">Mozambique</option>
                            <option value="MM">Myanmar</option>
                            <option value="NA">Namibia</option>
                            <option value="NR">Nauru</option>
                            <option value="NP">Nepal</option>
                            <option value="NL">Netherlands</option>
                            <option value="NC">New Caledonia</option>
                            <option value="NZ">New Zealand</option>
                            <option value="NI">Nicaragua</option>
                            <option value="NE">Niger</option>
                            <option value="NG">Nigeria</option>
                            <option value="NU">Niue</option>
                            <option value="NF">Norfolk Island</option>
                            <option value="MP">Northern Mariana Islands</option>
                            <option value="NO">Norway</option>
                            <option value="OM">Oman</option>
                            <option value="PK">Pakistan</option>
                            <option value="PW">Palau</option>
                            <option value="PS">
                              Palestinian Territory, Occupied
                            </option>
                            <option value="PA">Panama</option>
                            <option value="PG">Papua New Guinea</option>
                            <option value="PY">Paraguay</option>
                            <option value="PE">Peru</option>
                            <option value="PH">Philippines</option>
                            <option value="PN">Pitcairn</option>
                            <option value="PL">Poland</option>
                            <option value="PT">Portugal</option>
                            <option value="PR">Puerto Rico</option>
                            <option value="QA">Qatar</option>
                            <option value="RE">Réunion</option>
                            <option value="RO">Romania</option>
                            <option value="RU">Russian Federation</option>
                            <option value="RW">Rwanda</option>
                            <option value="BL">Saint Barthélemy</option>
                            <option value="SH">
                              Saint Helena, Ascension and Tristan da Cunha
                            </option>
                            <option value="KN">Saint Kitts and Nevis</option>
                            <option value="LC">Saint Lucia</option>
                            <option value="MF">
                              Saint Martin (French part)
                            </option>
                            <option value="PM">
                              Saint Pierre and Miquelon
                            </option>
                            <option value="VC">
                              Saint Vincent and the Grenadines
                            </option>
                            <option value="WS">Samoa</option>
                            <option value="SM">San Marino</option>
                            <option value="ST">Sao Tome and Principe</option>
                            <option value="SA">Saudi Arabia</option>
                            <option value="SN">Senegal</option>
                            <option value="RS">Serbia</option>
                            <option value="SC">Seychelles</option>
                            <option value="SL">Sierra Leone</option>
                            <option id="singapore" value="SG">
                              Singapore
                            </option>
                            <option value="SX">
                              Sint Maarten (Dutch part)
                            </option>
                            <option value="SK">Slovakia</option>
                            <option value="SI">Slovenia</option>
                            <option value="SB">Solomon Islands</option>
                            <option value="SO">Somalia</option>
                            <option value="ZA">South Africa</option>
                            <option value="GS">
                              South Georgia and the South Sandwich Islands
                            </option>
                            <option value="SS">South Sudan</option>
                            <option value="ES">Spain</option>
                            <option value="LK">Sri Lanka</option>
                            <option value="SD">Sudan</option>
                            <option value="SR">Suriname</option>
                            <option value="SJ">Svalbard and Jan Mayen</option>
                            <option value="SZ">Swaziland</option>
                            <option value="SE">Sweden</option>
                            <option value="CH">Switzerland</option>
                            <option value="SY">Syrian Arab Republic</option>
                            <option value="TW">
                              Taiwan, Province of China
                            </option>
                            <option value="TJ">Tajikistan</option>
                            <option value="TZ">
                              Tanzania, United Republic of
                            </option>
                            <option value="TH">Thailand</option>
                            <option value="TL">Timor-Leste</option>
                            <option value="TG">Togo</option>
                            <option value="TK">Tokelau</option>
                            <option value="TO">Tonga</option>
                            <option value="TT">Trinidad and Tobago</option>
                            <option value="TN">Tunisia</option>
                            <option value="TR">Turkey</option>
                            <option value="TM">Turkmenistan</option>
                            <option value="TC">Turks and Caicos Islands</option>
                            <option value="TV">Tuvalu</option>
                            <option value="UG">Uganda</option>
                            <option value="UA">Ukraine</option>
                            <option value="AE">United Arab Emirates</option>
                            <option value="GB">United Kingdom</option>
                            <option value="US">United States</option>
                            <option value="UM">
                              United States Minor Outlying Islands
                            </option>
                            <option value="UY">Uruguay</option>
                            <option value="UZ">Uzbekistan</option>
                            <option value="VU">Vanuatu</option>
                            <option value="VE">
                              Venezuela, Bolivarian Republic of
                            </option>
                            <option value="VN">Viet Nam</option>
                            <option value="VG">Virgin Islands, British</option>
                            <option value="VI">Virgin Islands, U.S.</option>
                            <option value="WF">Wallis and Futuna</option>
                            <option value="EH">Western Sahara</option>
                            <option value="YE">Yemen</option>
                            <option value="ZM">Zambia</option>
                            <option value="ZW">Zimbabwe</option>
                          </select>
                          {showStep2Errors && errors.country && (
                            <p className="text-red-500 text-sm">
                              {errors.country}
                            </p>
                          )}
                        </div>
                        <div className="flex-1">
                          <label className="block text-gray-700 text-sm">
                            Postal Code
                          </label>
                          <input
                            id="pin-code"
                            type="text"
                            name="zip"
                            value={zip}
                            onChange={(e) => {
                              const newZip = e.target.value;
                              setzip(newZip);

                              // Auto-fill logic
                              if (newZip.length === 6) {
                                // For Indian postal codes
                                fetchPostalCodeData(newZip).then((data) => {
                                  if (data) {
                                    setCity(data.city);
                                    setState(data.state);
                                    setCountry(data.country);
                                  }
                                });
                              }
                            }}
                            className="w-full px-3 py-0 border rounded text-black"
                            autoComplete="new-password" // Prevent browser autofill
                            required
                          />
                          {showStep2Errors && errors.zip && (
                            <p className="text-red-500 text-sm">{errors.zip}</p>
                          )}
                        </div>
                      </div>
                      <div className="mb-6">
                        <label className="flex items-start space-x-3">
                          <input
                            id="newsletter-checkbox"
                            type="checkbox"
                            checked={checklist}
                            onChange={(e) => setChecklist(e.target.checked)}
                            className="mt-1 h-4 w-4 text-[#19188B] focus:ring-[#19188B] border-gray-300 rounded"
                          />
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Yes, I’d like to receive AI tips, articles, product
                            updates, and other news from Random Walk. I
                            understand I can unsubscribe anytime.
                          </span>
                        </label>
                      </div>
                      <div className="flex pt-2">
                        <button
                          id="reverse"
                          type="button"
                          className=" mr-4 text-xs px-4 py-2 border border-blue-900 text-black rounded-full"
                          onClick={() => {
                            setStep(1);
                            setIsLoadingLiteracy(false); // Reset loading state when going back
                          }}
                        >
                          Back
                        </button>
                        <button
                          id="submit-and-checkout"
                          onClick={handleClickLiteracy}
                          type="button"
                          disabled={isLoadingLiteracy}
                          className="px-7 py-2 bg-[#19188B] text-xs text-white rounded-full flex items-center justify-center"
                        >
                          {isLoadingLiteracy ? (
                            <>
                              <svg
                                className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                              </svg>
                              Processing...
                            </>
                          ) : (
                            "Submit & Checkout"
                          )}
                        </button>
                      </div>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        )}

        {pageFullyLoaded && isLiteracyFormOpen && (
          <div className="fixed max-md:hidden font-display z-50 md:p-10 lg:p-32  inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white rounded-lg  w-full  flex relative  ">
              <button
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                onClick={closeModal}
                id="form-close-button"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="4"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
              <div
                className="bg-[#C6A4FF] w-full  flex flex-col items-start justify-center rounded-l-lg bg-no-repeat bg-cover  "
                style={{
                  backgroundImage: `url(${bgimg1})`, // replace with new image
                  backgroundPosition: "center",
                }}
              >
                <div className="flex flex-col items-start justify-center">
                  <div className="text-sm md:text-sm lg:text-2xl 2xl:pt-10  font-normal ml-10 pb-3 text-white text-center">
                    Discover your AI Literacy
                  </div>
                  <div className="text-sm font-bold md:text-xs lg:text-xl ml-10 pb-3 text-white text-left">
                    AI Literacy Assessment
                  </div>
                </div>
                <img
                  src={test2}
                  alt="Description of image"
                  className="md:w-full  2xl:pb-5  px-5 h-auto"
                />
              </div>

              <button
                id="arrrow-symbol"
                className={`absolute left-1/2 md:top-10 lg:top-24 -translate-x-10 transform flex items-center justify-center md:w-7 md:h-7 lg:w-8 lg:h-8 bg-[#040330] text-[#3E1D9E] font-bold rounded-full cursor-default 
              `}
              >
                {step === 1 ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#FFFFFF"
                    className="md:w-3 md:h-3 lg:w-4 lg:h-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M2 12h20m-7-7 7 7-7 7"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#FFFFFF"
                    className="md:w-3 md:h-3 lg:w-4 lg:h-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M2 12h20m-7-7 7 7-7 7"
                    />
                  </svg>
                )}
              </button>

              <div className=" p-8 w-full justify-center items-center">
                <div className="flex justify-center mb-4 ">
                  <div className="absolute top-0 bg-[#C6A4FF] text-white px-4 py-3 inline-block rounded-md">
                    <h2 className="text-lg font-semibold font-display ">
                      For Individuals
                    </h2>
                  </div>
                </div>

                <div className=" font-normal mb-2   lg:text-xl md:text-sm text-black text-left mt-8">
                  Please fill the form to proceed payment
                </div>
                <form>
                  {step === 1 && (
                    <>
                      <div className="mb-2">
                        <label className=" text-gray-700">
                          First Name{" "}
                          {showStep1Errors && errors.userName && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.userName}
                            </span>
                          )}
                        </label>
                        <input
                          id="first-name-desktop"
                          type="text"
                          name="userName"
                          value={userName}
                          onChange={(e) => setUserName(e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded text-black"
                        />
                      </div>
                      <div className="mb-2">
                        <label className=" text-gray-700">
                          Last Name
                          {showStep1Errors && errors.lastName && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.lastName}
                            </span>
                          )}
                        </label>
                        <input
                          last-name-desktop
                          type="text"
                          name="name"
                          value={lastName}
                          onChange={(e) => setlastName(e.target.value)}
                          className="w-full px-3 py-2 border rounded text-black"
                          required
                        />
                      </div>

                      <div className="mb-2">
                        <label className=" text-gray-700">
                          Email Address
                          {showStep1Errors && errors.email && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.email}
                            </span>
                          )}
                        </label>
                        <input
                          id="email-desktop"
                          type="email"
                          name="email"
                          value={email}
                          onChange={(e) => setEmailId(e.target.value)}
                          className="w-full px-3 py-2 border rounded border-gray-300 text-black"
                        />
                      </div>
                      <div className="mb-2">
                        <label className="text-gray-700">
                          Phone Number
                          {showStep1Errors && errors.userphoneNumber && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.userphoneNumber}
                            </span>
                          )}
                        </label>
                        <PhoneInput
                          mobile-numer-desktop
                          id="phone-number-desktop"
                          country={"in"}
                          value={userphoneNumber}
                          onChange={setusersphoneNumber}
                          inputClass="custom-phone-input4"
                          buttonClass="border rounded"
                          dropdownClass="border rounded"
                          className="text-black"
                          autocomplete="off"
                          enableSearch={true}
                          inputProps={{
                            required: true,
                            autoFocus: false,
                          }}
                        />
                      </div>

                      <div className="mb-2">
                        <label className=" text-gray-700 text-sm">
                          Job Title
                          {showStep1Errors && errors.jobTitle && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.jobTitle}
                            </span>
                          )}
                        </label>
                        <input
                          job-title-desktop
                          type="text"
                          name="jobTitle"
                          value={jobTitle}
                          onChange={(e) => setjobTtitle(e.target.value)}
                          className="w-full px-3 py-2 border rounded text-black"
                          required
                        />
                      </div>
                      <div className="mb-2">
                        <label className="text-gray-700 text-sm">
                          Company Name
                          {showStep1Errors && errors.literacycompanyName && (
                            <span className="text-red-500 text-sm ml-2">
                              {errors.literacycompanyName}
                            </span>
                          )}
                        </label>
                        <input
                          literacy-company-name-desktop
                          type="text"
                          name="literacycompanyName"
                          value={literacycompanyName}
                          onChange={(e) =>
                            setLiteracyCompanyName(e.target.value)
                          }
                          className="w-full px-3 py-2 border rounded border-gray-300 text-black"
                          required
                        />
                      </div>
                      <div className="flex justify-start">
                        <button
                          id="after"
                          type="button"
                          className="px-7 py-2 bg-[#19188B] text-white rounded-full"
                          onClick={handleNextClick}
                        >
                          Next
                        </button>
                      </div>
                    </>
                  )}
                  {step === 2 && (
                    <>
                      <h1 className="text-gray-700 text-base ">
                        Billing Address:
                      </h1>
                      <div className="mb-4">
                        <label className="block text-gray-700">Street</label>
                        <textarea
                          id="street-name"
                          name="street"
                          value={street}
                          onChange={(e) => setstreet(e.target.value)}
                          className="w-full px-3 py-0 border rounded border-gray-300 text-black"
                        ></textarea>
                        {showStep2Errors && errors.street && (
                          <p className="text-red-500 text-sm">
                            {errors.street}
                          </p>
                        )}
                      </div>
                      <div className="flex gap-4 mb-4">
                        <div className="flex-1">
                          <label className="block text-gray-700 text-sm ">
                            City
                            {showStep2Errors && errors.city && (
                              <span className="text-red-500 text-sm ml-2">
                                {errors.city}
                              </span>
                            )}
                          </label>
                          <input
                            id="city-form"
                            type="text"
                            name="city"
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            className={`w-full px-3 py-0 border rounded text-black ${
                              zip.length === 6 ? "bg-gray-100" : ""
                            }`}
                            required
                          />
                        </div>
                        <div className="flex-1">
                          <label className="block text-gray-700 text-sm">
                            State
                            {showStep2Errors && errors.state && (
                              <span className="text-red-500 text-sm ml-2">
                                {errors.state}
                              </span>
                            )}
                          </label>
                          <input
                            id="state-name-form"
                            type="text"
                            name="state"
                            value={state}
                            onChange={(e) => setState(e.target.value)}
                            className={`w-full px-3 py-0 border rounded text-black ${
                              zip.length === 6 ? "bg-gray-100" : ""
                            }`}
                            required
                          />
                        </div>
                      </div>
                      <div className="flex gap-4 mb-4">
                        <div className="flex-1 text-black ">
                          <label className="block text-gray-700">Country</label>
                          <select
                            id="country-name"
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            className="w-full px-3 py-1 border rounded border-gray-300 text-black"
                            required
                          >
                            <option value="">--Select--</option>
                            <option value="AF">Afghanistan</option>
                            <option value="AX">Åland Islands</option>
                            <option value="AL">Albania</option>
                            <option value="DZ">Algeria</option>
                            <option value="AS">American Samoa</option>
                            <option value="AD">Andorra</option>
                            <option value="AO">Angola</option>
                            <option value="AI">Anguilla</option>
                            <option value="AQ">Antarctica</option>
                            <option value="AG">Antigua and Barbuda</option>
                            <option value="AR">Argentina</option>
                            <option value="AM">Armenia</option>
                            <option value="AW">Aruba</option>
                            <option value="AU">Australia</option>
                            <option value="AT">Austria</option>
                            <option value="AZ">Azerbaijan</option>
                            <option value="BS">Bahamas</option>
                            <option value="BH">Bahrain</option>
                            <option value="BD">Bangladesh</option>
                            <option value="BB">Barbados</option>
                            <option value="BY">Belarus</option>
                            <option value="BE">Belgium</option>
                            <option value="BZ">Belize</option>
                            <option value="BJ">Benin</option>
                            <option value="BM">Bermuda</option>
                            <option value="BT">Bhutan</option>
                            <option value="BO">
                              Bolivia, Plurinational State of
                            </option>
                            <option value="BQ">
                              Bonaire, Sint Eustatius and Saba
                            </option>
                            <option value="BA">Bosnia and Herzegovina</option>
                            <option value="BW">Botswana</option>
                            <option value="BV">Bouvet Island</option>
                            <option value="BR">Brazil</option>
                            <option value="IO">
                              British Indian Ocean Territory
                            </option>
                            <option value="BN">Brunei Darussalam</option>
                            <option value="BG">Bulgaria</option>
                            <option value="BF">Burkina Faso</option>
                            <option value="BI">Burundi</option>
                            <option value="KH">Cambodia</option>
                            <option value="CM">Cameroon</option>
                            <option value="CA">Canada</option>
                            <option value="CV">Cape Verde</option>
                            <option value="KY">Cayman Islands</option>
                            <option value="CF">Central African Republic</option>
                            <option value="TD">Chad</option>
                            <option value="CL">Chile</option>
                            <option value="CN">China</option>
                            <option value="CX">Christmas Island</option>
                            <option value="CC">Cocos (Keeling) Islands</option>
                            <option value="CO">Colombia</option>
                            <option value="KM">Comoros</option>
                            <option value="CG">Congo</option>
                            <option value="CD">
                              Congo, the Democratic Republic of the
                            </option>
                            <option value="CK">Cook Islands</option>
                            <option value="CR">Costa Rica</option>
                            <option value="CI">Côte d'Ivoire</option>
                            <option value="HR">Croatia</option>
                            <option value="CU">Cuba</option>
                            <option value="CW">Curaçao</option>
                            <option value="CY">Cyprus</option>
                            <option value="CZ">Czech Republic</option>
                            <option value="DK">Denmark</option>
                            <option value="DJ">Djibouti</option>
                            <option value="DM">Dominica</option>
                            <option value="DO">Dominican Republic</option>
                            <option value="EC">Ecuador</option>
                            <option value="EG">Egypt</option>
                            <option value="SV">El Salvador</option>
                            <option value="GQ">Equatorial Guinea</option>
                            <option value="ER">Eritrea</option>
                            <option value="EE">Estonia</option>
                            <option value="ET">Ethiopia</option>
                            <option value="FK">
                              Falkland Islands (Malvinas)
                            </option>
                            <option value="FO">Faroe Islands</option>
                            <option value="FJ">Fiji</option>
                            <option value="FI">Finland</option>
                            <option value="FR">France</option>
                            <option value="GF">French Guiana</option>
                            <option value="PF">French Polynesia</option>
                            <option value="TF">
                              French Southern Territories
                            </option>
                            <option value="GA">Gabon</option>
                            <option value="GM">Gambia</option>
                            <option value="GE">Georgia</option>
                            <option value="DE">Germany</option>
                            <option value="GH">Ghana</option>
                            <option value="GI">Gibraltar</option>
                            <option value="GR">Greece</option>
                            <option value="GL">Greenland</option>
                            <option value="GD">Grenada</option>
                            <option value="GP">Guadeloupe</option>
                            <option value="GU">Guam</option>
                            <option value="GT">Guatemala</option>
                            <option value="GG">Guernsey</option>
                            <option value="GN">Guinea</option>
                            <option value="GW">Guinea-Bissau</option>
                            <option value="GY">Guyana</option>
                            <option value="HT">Haiti</option>
                            <option value="HM">
                              Heard Island and McDonald Islands
                            </option>
                            <option value="VA">
                              Holy See (Vatican City State)
                            </option>
                            <option value="HN">Honduras</option>
                            <option value="HK">Hong Kong</option>
                            <option value="HU">Hungary</option>
                            <option value="IS">Iceland</option>
                            <option value="IN">India</option>
                            <option value="ID">Indonesia</option>
                            <option value="IR">
                              Iran, Islamic Republic of
                            </option>
                            <option value="IQ">Iraq</option>
                            <option value="IE">Ireland</option>
                            <option value="IM">Isle of Man</option>
                            <option value="IL">Israel</option>
                            <option value="IT">Italy</option>
                            <option value="JM">Jamaica</option>
                            <option value="JP">Japan</option>
                            <option value="JE">Jersey</option>
                            <option value="JO">Jordan</option>
                            <option value="KZ">Kazakhstan</option>
                            <option value="KE">Kenya</option>
                            <option value="KI">Kiribati</option>
                            <option value="KP">
                              Korea, Democratic People's Republic of
                            </option>
                            <option value="KR">Korea, Republic of</option>
                            <option value="KW">Kuwait</option>
                            <option value="KG">Kyrgyzstan</option>
                            <option value="LA">
                              Lao People's Democratic Republic
                            </option>
                            <option value="LV">Latvia</option>
                            <option value="LB">Lebanon</option>
                            <option value="LS">Lesotho</option>
                            <option value="LR">Liberia</option>
                            <option value="LY">Libya</option>
                            <option value="LI">Liechtenstein</option>
                            <option value="LT">Lithuania</option>
                            <option value="LU">Luxembourg</option>
                            <option value="MO">Macao</option>
                            <option value="MK">
                              Macedonia, the former Yugoslav Republic of
                            </option>
                            <option value="MG">Madagascar</option>
                            <option value="MW">Malawi</option>
                            <option value="MY">Malaysia</option>
                            <option value="MV">Maldives</option>
                            <option value="ML">Mali</option>
                            <option value="MT">Malta</option>
                            <option value="MH">Marshall Islands</option>
                            <option value="MQ">Martinique</option>
                            <option value="MR">Mauritania</option>
                            <option value="MU">Mauritius</option>
                            <option value="YT">Mayotte</option>
                            <option value="MX">Mexico</option>
                            <option value="FM">
                              Micronesia, Federated States of
                            </option>
                            <option value="MD">Moldova, Republic of</option>
                            <option value="MC">Monaco</option>
                            <option value="MN">Mongolia</option>
                            <option value="ME">Montenegro</option>
                            <option value="MS">Montserrat</option>
                            <option value="MA">Morocco</option>
                            <option value="MZ">Mozambique</option>
                            <option value="MM">Myanmar</option>
                            <option value="NA">Namibia</option>
                            <option value="NR">Nauru</option>
                            <option value="NP">Nepal</option>
                            <option value="NL">Netherlands</option>
                            <option value="NC">New Caledonia</option>
                            <option value="NZ">New Zealand</option>
                            <option value="NI">Nicaragua</option>
                            <option value="NE">Niger</option>
                            <option value="NG">Nigeria</option>
                            <option value="NU">Niue</option>
                            <option value="NF">Norfolk Island</option>
                            <option value="MP">Northern Mariana Islands</option>
                            <option value="NO">Norway</option>
                            <option value="OM">Oman</option>
                            <option value="PK">Pakistan</option>
                            <option value="PW">Palau</option>
                            <option value="PS">
                              Palestinian Territory, Occupied
                            </option>
                            <option value="PA">Panama</option>
                            <option value="PG">Papua New Guinea</option>
                            <option value="PY">Paraguay</option>
                            <option value="PE">Peru</option>
                            <option value="PH">Philippines</option>
                            <option value="PN">Pitcairn</option>
                            <option value="PL">Poland</option>
                            <option value="PT">Portugal</option>
                            <option value="PR">Puerto Rico</option>
                            <option value="QA">Qatar</option>
                            <option value="RE">Réunion</option>
                            <option value="RO">Romania</option>
                            <option value="RU">Russian Federation</option>
                            <option value="RW">Rwanda</option>
                            <option value="BL">Saint Barthélemy</option>
                            <option value="SH">
                              Saint Helena, Ascension and Tristan da Cunha
                            </option>
                            <option value="KN">Saint Kitts and Nevis</option>
                            <option value="LC">Saint Lucia</option>
                            <option value="MF">
                              Saint Martin (French part)
                            </option>
                            <option value="PM">
                              Saint Pierre and Miquelon
                            </option>
                            <option value="VC">
                              Saint Vincent and the Grenadines
                            </option>
                            <option value="WS">Samoa</option>
                            <option value="SM">San Marino</option>
                            <option value="ST">Sao Tome and Principe</option>
                            <option value="SA">Saudi Arabia</option>
                            <option value="SN">Senegal</option>
                            <option value="RS">Serbia</option>
                            <option value="SC">Seychelles</option>
                            <option value="SL">Sierra Leone</option>
                            <option id="singapore" value="SG">
                              Singapore
                            </option>
                            <option value="SX">
                              Sint Maarten (Dutch part)
                            </option>
                            <option value="SK">Slovakia</option>
                            <option value="SI">Slovenia</option>
                            <option value="SB">Solomon Islands</option>
                            <option value="SO">Somalia</option>
                            <option value="ZA">South Africa</option>
                            <option value="GS">
                              South Georgia and the South Sandwich Islands
                            </option>
                            <option value="SS">South Sudan</option>
                            <option value="ES">Spain</option>
                            <option value="LK">Sri Lanka</option>
                            <option value="SD">Sudan</option>
                            <option value="SR">Suriname</option>
                            <option value="SJ">Svalbard and Jan Mayen</option>
                            <option value="SZ">Swaziland</option>
                            <option value="SE">Sweden</option>
                            <option value="CH">Switzerland</option>
                            <option value="SY">Syrian Arab Republic</option>
                            <option value="TW">
                              Taiwan, Province of China
                            </option>
                            <option value="TJ">Tajikistan</option>
                            <option value="TZ">
                              Tanzania, United Republic of
                            </option>
                            <option value="TH">Thailand</option>
                            <option value="TL">Timor-Leste</option>
                            <option value="TG">Togo</option>
                            <option value="TK">Tokelau</option>
                            <option value="TO">Tonga</option>
                            <option value="TT">Trinidad and Tobago</option>
                            <option value="TN">Tunisia</option>
                            <option value="TR">Turkey</option>
                            <option value="TM">Turkmenistan</option>
                            <option value="TC">Turks and Caicos Islands</option>
                            <option value="TV">Tuvalu</option>
                            <option value="UG">Uganda</option>
                            <option value="UA">Ukraine</option>
                            <option value="AE">United Arab Emirates</option>
                            <option value="GB">United Kingdom</option>
                            <option value="US">United States</option>
                            <option value="UM">
                              United States Minor Outlying Islands
                            </option>
                            <option value="UY">Uruguay</option>
                            <option value="UZ">Uzbekistan</option>
                            <option value="VU">Vanuatu</option>
                            <option value="VE">
                              Venezuela, Bolivarian Republic of
                            </option>
                            <option value="VN">Viet Nam</option>
                            <option value="VG">Virgin Islands, British</option>
                            <option value="VI">Virgin Islands, U.S.</option>
                            <option value="WF">Wallis and Futuna</option>
                            <option value="EH">Western Sahara</option>
                            <option value="YE">Yemen</option>
                            <option value="ZM">Zambia</option>
                            <option value="ZW">Zimbabwe</option>
                          </select>
                          {showStep2Errors && errors.country && (
                            <p className="text-red-500 text-sm">
                              {errors.country}
                            </p>
                          )}
                        </div>
                        <div className="flex-1">
                          <label className="block text-gray-700 text-sm">
                            Postal Code
                          </label>
                          <input
                            id="pin-code"
                            type="text"
                            name="zip"
                            value={zip}
                            onChange={(e) => {
                              const newZip = e.target.value;
                              setzip(newZip);

                              // Auto-fill logic
                              if (newZip.length === 6) {
                                // For Indian postal codes
                                fetchPostalCodeData(newZip).then((data) => {
                                  if (data) {
                                    setCity(data.city);
                                    setState(data.state);
                                    setCountry(data.country);
                                  }
                                });
                              }
                            }}
                            className="w-full px-3 py-0.5 border rounded text-black"
                            autoComplete="new-password" // Prevent browser autofill
                            required
                          />
                          {showStep2Errors && errors.zip && (
                            <p className="text-red-500 text-sm">{errors.zip}</p>
                          )}
                        </div>
                      </div>
                      <div className="mb-6">
                        <label className="flex items-start space-x-3">
                          <input
                            id="newsletter-checkbox"
                            type="checkbox"
                            checked={checklist}
                            onChange={(e) => setChecklist(e.target.checked)}
                            className="mt-1 h-4 w-4 text-[#19188B] focus:ring-[#19188B] border-gray-300 rounded"
                          />
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Yes, I’d like to receive AI tips, articles, product
                            updates, and other news from Random Walk. I
                            understand I can unsubscribe anytime.
                          </span>
                        </label>
                      </div>
                      <div className="flex justify-end">
                        <button
                          id="before"
                          type="button"
                          className="mr-4 px-7 py-2 border border-blue-900 text-black rounded-full"
                          onClick={() => setStep(1)}
                        >
                          Back
                        </button>
                        <button
                          id="submit-and-checkout"
                          onClick={handleClickLiteracy}
                          // Keep as type="button" to prevent form submission behavior
                          type="button"
                          disabled={isLoadingLiteracy}
                          className="px-7 py-2 bg-[#19188B] text-xs text-white rounded-full flex items-center justify-center"
                        >
                          {isLoadingLiteracy ? (
                            <>
                              <svg
                                className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                              </svg>
                              Processing...
                            </>
                          ) : (
                            "Submit & Checkout"
                          )}
                        </button>
                      </div>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default LiteracyPage;
